export default {
  spanish: 'Espagnol',
  english: 'Anglais',
  addPrinter: {
    title: "Ajouter une imprimante",
    detectPrinters: "Détection automatique des imprimantes",
    printerName: "Nom de l'imprimante",
    printerType: "Type d'imprimante",
    laser: "Imprimante laser",
    receipt: "Imprimante de reçus",
    barcode: "Imprimante de codes-barres",
    connectionType: "Type de connexion",
    network: "Réseau",
    ipAddress: "Adresse IP",
    port: "Port",
    driverType: "Type de pilote",
    printSpeed: "Vitesse d'impression",
    autoCutter: "Coupe-papier automatique",
    cashDrawerPort: "Port du tiroir-caisse",
    printDensity: "Densité d'impression",
    savePrinter: "Enregistrer l'imprimante",
    detectionCompleted: "Détection d'imprimante terminée.",
    fillAllFields: "Veuillez remplir tous les champs obligatoires.",
    success: "Imprimante ajoutée avec succès !",
    scanning: "Recherche d'imprimantes...",
    detectionSuccess: "Imprimante détectée avec succès !",
    noPrintersFound: "Aucune imprimante trouvée.",
    detectionError: "Erreur lors de la détection des imprimantes."
  },
  // Agrega aquí las demás traducciones siguiendo la estructura del archivo i18n.js
  backoffice:{
    printerManager: {
      title: "Gestionnaire d'imprimantes",
      printers: "Imprimantes",
      select: "Sélectionner",
      discoverPrinters: "Découvrir les imprimantes",
      showAddPrinter: "Ajouter une imprimante",
      printTest: "Imprimer une page de test",
      scanBluetooth: "Rechercher des imprimantes Bluetooth",
      printerName: "Nom de l'imprimante",
      printerType: "Type d'imprimante",
      laser: "Imprimante laser (A4)",
      receipt: "Imprimante de reçus",
      barcode: "Imprimante à codes-barres",
      autoCutter: "Coupe automatique",
      driverType: "Type de pilote",
      connectionType: "Type de connexion",
      ipAddress: "Adresse IP",
      port: "Port",
      mac: "Adresse MAC",
      isDefault: "Défaut",
      add: "Ajouter",
      cancel: "Annuler",
      noPrintersFound: "Aucune imprimante trouvée.",
      printSentSuccess: "Impression envoyée avec succès à l'imprimante réseau.",
      printFailedBackend: "Échec de l'impression sur le backend.",
      networkPrintError: "Erreur d'impression réseau : {error}",
      usbPrintError: "Erreur d'impression USB. Vérifiez les connexions !",
      noUSBPrinters: "Aucune imprimante USB détectée !",
      bluetoothPrintError: "Erreur d'impression Bluetooth : vérifiez la connexion !",
      printFailed: "Échec de l'impression. Veuillez vérifier la connexion de l'imprimante et réessayer.",
      selectPrinterType: "Sélectionner Printer Connection Type",
      inputPlaceholder: "Sélectionner a type connection",
      pleaseSelectPrinterType: "Veuillez sélectionner un type d'imprimante.",
      invalidPrinterType: "Type d'imprimante sélectionné invalide.",
      scannedFromBLE: "Scanné depuis BLE : {barcode}"
    },
    bleScanner: {
      title: "Scanner et imprimante BLE",
      deviceType: "Type d'appareil",
      scanner: "Scanner de codes-barres",
      printer: "Imprimante",
      scanDevices: "Rechercher des appareils BLE",
      unnamedDevice: "Appareil sans nom",
      connect: "Connect",
      scannedBarcode: "Code-barres scanné :",
      printData: "Données à imprimer",
      enterPrintText: "Saisir le texte à imprimer",
      sendToPrinter: "Envoyer à l'imprimante",
      bleScanError: "Erreur de scan BLE : {error}",
      connectionSuccess: "Connecté à {device}",
      connectionError: "Erreur de connexion : {error}",
      notificationError: "Erreur de notification : {error}",
      scanned: "Scanné : {barcode}",
      noPrinterOrData: "Aucune imprimante connectée ou données d'impression vides.",
      printDataSent: "Données envoyées à l'imprimante.",
      printError: "Erreur d'impression : {error}"
    },
    interactions: {
      lastContacted: 'Dernier Contact',
      notesLastContacted: 'Notes Dernier Contact',
      nextFollowUp: 'Suivant Suivi',
      notesNextFollowUp: 'Notes Suivant Suivi',
      preferredContactTime: 'Heure Préférée de Contact',
      notesContactToTime: 'Notes Heure Préférée de Contact',
      selectSubscriber: 'Sélectionner un abonné',
      selectSubscriberDescription: 'Sélectionner un abonné pour ajouter ou afficher ses informations',
      selectSubscriberInput: 'Sélectionner un abonné',
      selectSubscriberInputPlaceholder: 'Sélectionner un abonné',
      createSubscriber: 'Créer un abonné',
      cancel: 'Annuler',
      //customers
      selectCustomer: 'Sélectionner un client',
      selectCustomerDescription: 'Sélectionner un client pour ajouter ou afficher ses informations',
      selectCustomerInput: 'Sélectionner un client',
      selectCustomerInputPlaceholder: 'Sélectionner un client',
      createCustomer: 'Créer un client',
    },
    cCardSaved:{
      paymentManagement: 'Gestion des paiements',
      clickToManageCards: 'Cliquez ici pour ajouter ou afficher vos cartes enregistrées',
      creditCards: 'Cartes de crédit',
      addCreditCard: 'Ajouter une carte de crédit',
    },
    virtualTerminal: {
      acordeon1: {
        title: 'Informations de paiement/autorisation',
        subtitle: 'Méthode de paiement acceptée : American Express, Discover, Mastercard',
        cardNumber: 'Numéro de carte',
        expirationDate: 'Date d\'expiration',
        amount: 'Montant'
      },
      acordeon2: {
        title: 'Informations de commande',
        subscriptionName: 'Nom de l\'abonnement',
        invoice: 'Facture #',
        description: 'Description',
        placeholder: 'Saisissez plus d\'informations ici...'
      },
      acordeon3: {
        title: 'Intervalle d\'abonnement',
        subtitle: 'Sélectionnez la fréquence de facturation du client.',
        selectOption: 'Sélectionner une option',
        interval1: 'Mensuel',
        interval2: 'Trimestriel',
        interval3: 'Semestriel',
        interval4: 'Annuel'
      },
      acordeon4: {
        title: 'Durée de l\'abonnement',
        startDate: 'Date de début',
        noEnd: 'Pas de date de fin (abonnement continu)',
        endDate: 'Date de fin',
        endAfter: 'Terminer après'
      },
      acordeon5: {
        title: 'Paiement',
        nameAcount: 'Nom sur le compte',
        paymentType: 'Type de paiement',
        creditCard: 'Carte de crédit',
        subscriptionName: 'Nom de l\'abonnement',
        trialAmount: 'Montant d\'essai',
        firstName: 'Prénom',
        sameAsBilling: 'Identique à l\'adresse de facturation'
      }
    },
    worksheetStatus: {
      draft: 'Brouillon',
      opened: 'Ouvert',
      closed: 'Fermé',
      worksheetDetail: 'Détails de la feuille de travail',
      fields: {
        responsable: 'Responsable',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        workers: 'Travailleurs'
      },
      tooltip: {
        staffWorker: 'Ajouter un employé',
        resetAllCalendar: 'Réinitialiser tous les calendriers',
        showCalendarDetails: 'Afficher les détails du calendrier',
        resetCalendar: 'Réinitialiser ce calendrier',
        removeStaffWorker: 'Supprimer un employé',
        debit: 'Ce sont vos dépenses. Argent qui est payé.',
        credit: 'Ce sont vos revenus. Argent qui vous est versé.',
        payee: 'C\'est la personne que vous avez payée ou qui vous a payé.',
        category: 'C\'est le type de paiement ou de crédit.',
        bestRepresentation: 'C\'est la meilleure estimation du système pour la catégorie.'
      },
      message: {
        totalHour: 'Total des heures travaillées :',
        hours: 'heures',
        with: 'avec',
        minutes: 'minutes',
        typeMessage: 'Saisissez un message ici...'
      },
      button: {
        saveDraft: 'Enregistrer comme brouillon',
        saveOpen: 'Enregistrer et ouvrir',
        close: 'Fermer',
        addShift: 'Ajouter un quart de travail',
        changeworksheetRequest: 'Demande de modification'
      }
    },
    mastercard: {
      accountInfo: 'Informations sur le compte',
      mastercardUserDetails: 'Détails de l\'utilisateur Mastercard',
      seeLinedAccounts: 'Voir les comptes liés',
      addMoreBanks: 'Ajouter plus de banques',
      linkedBanks: 'Comptes liés',
      viewTransactions: 'Voir les transactions',
      linesPerPage: 'Nombre de lignes par page',
    },
    transactionData: {
      revenue: "Revenu",
      revenueDescription: "Activez ce commutateur si la transaction est une entrée de revenu.",
      transactionId: "ID de transaction",
      transactionIdDescription: "Saisissez l'ID de transaction unique associé à cette transaction.",
      transactionAmount: "Montant de la transaction (USD)",
      transactionAmountDescription: "Saisissez le montant de la transaction en USD. C'est le montant impliqué dans la transaction.",
      accountId: "ID de compte",
      accountIdDescription: "Saisissez l'ID de compte unique associé à la transaction.",
      customerId: "ID client",
      customerIdDescription: "Saisissez l'ID client unique associé à la transaction.",
      transactionStatus: "Statut de la transaction",
      transactionStatusDescription: "Sélectionnez le statut actuel de la transaction parmi les options disponibles.",
      statusOptions: {
        active: "Actif",
        pending: "En attente",
        completed: "Terminé",
        failed: "Échoué",
        cancelled: "Annulé"
      },
      memo: "Mémo",
      memoDescription: "Saisissez toutes notes supplémentaires ou mémo pour la transaction.",
      transactionType: "Type de transaction",
      transactionTypeDescription: "Sélectionnez le type de transaction pour cette transaction.",
      transactionDate: "Date de transaction",
      transactionDateDescription: "Sélectionnez la date à laquelle la transaction a eu lieu.",
      typeOptions: {
        debit: "Débit",
        credit: "Crédit",
        transfer: "Transfert",
        payment: "Paiement",
        withdrawal: "Retrait",
        deposit: "Dépôt"
      },
      postedDate: "Date de comptabilisation",
      postedDateDescription: "Sélectionnez la date à laquelle la transaction a été comptabilisée.",
      createdDate: "Date de création",
      createdDateDescription: "Sélectionnez la date à laquelle la transaction a été créée.",
      firstEffectiveDate: "Première date effective",
      firstEffectiveDateDescription: "Sélectionnez la première date effective pour la transaction.",
      effectiveDate: "Date effective",
      effectiveDateDescription: "Sélectionnez la date effective pour la transaction.",
      optionExpireDate: "Date d'expiration de l'option",
      optionExpireDateDescription: "Sélectionnez la date d'expiration de l'option si applicable.",
      checkNumber: "Numéro de chèque",
      checkNumberDescription: "Saisissez le numéro de chèque si applicable. Laissez vide si non applicable.",
      escrowAmount: "Montant en séquestre (USD)",
      escrowAmountDescription: "Saisissez le montant en séquestre si applicable. C'est le montant détenu en séquestre pour la transaction.",
      transactionFeeAmount: "Montant des frais de transaction (USD)",
      transactionFeeAmountDescription: "Saisissez le montant des frais si applicable. Ce sont les frais facturés pour le traitement de la transaction.",
      suspenseAmount: "Montant en attente (USD)",
      suspenseAmountDescription: "Saisissez le montant en attente si applicable. Ceci est utilisé pour les transactions temporairement retenues ou en attente.",
      interestAmount: "Montant des intérêts (USD)",
      interestAmountDescription: "Saisissez le montant des intérêts si applicable. C'est le montant des intérêts accumulés sur la transaction.",
      principalAmount: "Montant principal (USD)",
      principalAmountDescription: "Saisissez le montant principal si applicable. C'est la somme d'argent initiale empruntée ou investie, hors intérêts ou frais.",
      optionStrikePrice: "Prix d'exercice de l'option (USD)",
      optionStrikePriceDescription: "Saisissez le prix d'exercice de l'option si applicable. C'est le prix auquel l'option peut être exercée.",
      unitQuantity: "Quantité unitaire",
      unitQuantityDescription: "Saisissez la quantité unitaire si applicable. C'est le nombre d'unités impliquées dans la transaction, comme des articles achetés ou des actions échangées.",
      unitPrice: "Prix unitaire (USD)",
      unitPriceDescription: "Saisissez le prix unitaire si applicable. Ceci est utilisé pour les transactions impliquant des titres ou des investissements.",
      transactionCategorization: "Catégorisation des transactions",
      normalizedPayeeName: "Nom du bénéficiaire normalisé",
      normalizedPayeeNameDescription: "Saisissez le nom du bénéficiaire dans un format standardisé. Ceci est utile pour assurer la cohérence des enregistrements.",
      transactionCategory: "Catégorie de transaction",
      transactionCategoryDescription: "Saisissez la catégorie de la transaction, comme 'vente', 'achat' ou 'transfert'.",
      customCategory: "Catégorie personnalisée",
      customCategoryDescription: "Saisissez une catégorie personnalisée si applicable. Ceci est pour les transactions qui ne correspondent pas aux catégories prédéfinies.",
      city: "Ville",
      cityDescription: "Saisissez la ville liée à la transaction.",
      state: "État",
      stateDescription: "Saisissez l'état ou la région où la transaction a eu lieu.",
      postalCode: "Code postal",
      postalCodeDescription: "Saisissez le code postal de l'emplacement associé à la transaction.",
      country: "Pays",
      countryDescription: "Saisissez le pays où la transaction a eu lieu.",
      bestRepresentation: "Meilleure représentation",
      bestRepresentationDescription: "Saisissez la meilleure représentation pour la transaction, qui pourrait être une description générale ou une classification.",
      runningBalanceAmountUSD: "Solde courant (USD)",
      runningBalanceAmountUSDDescription: "Saisissez le solde courant en USD, qui est le solde continu après le traitement de la transaction.",
      subaccountSecurityType: "Type de sécurité du sous-compte",
      subaccountSecurityTypeDescription: "Saisissez le type de sécurité associé au sous-compte, si applicable.",
      commissionAmountUSD: "Montant de la commission (USD)",
      commissionAmountUSDDescription: "Saisissez le montant de la commission en USD, si applicable. Ce sont les frais facturés pour la transaction.",
      tickerSymbol: "Symbole boursier",
      tickerSymbolDescription: "Saisissez le symbole boursier de l'actif ou du titre impliqué dans la transaction.",
      investmentTransactionType: "Type de transaction d'investissement",
      investmentTransactionTypeDescription: "Saisissez le type de transaction d'investissement, comme 'achat', 'vente' ou 'dividende'.",
      taxesAmountUSD: "Montant des taxes (USD)",
      taxesAmountUSDDescription: "Saisissez le montant des taxes liées à la transaction, en USD.",
      currencySymbol: "Symbole de devise",
      currencySymbolDescription: "Saisissez le symbole de la devise utilisée dans la transaction, comme '$' pour USD ou '€' pour EUR.",
      incomeType: "Type de revenu",
      incomeTypeDescription: "Saisissez le type de revenu, comme 'salaire', 'intérêts' ou 'plus-values'.",
      splitDenominator: "Dénominateur de division",
      splitDenominatorDescription: "Saisissez le dénominateur pour toute transaction fractionnée ou divisée, si applicable.",
      splitNumerator: "Numérateur de division",
      splitNumeratorDescription: "Saisissez le numérateur de division si applicable. Cette valeur est utilisée pour les transactions qui impliquent la division des montants entre plusieurs catégories ou comptes.",
      sharesPerContract: "Actions par contrat",
      sharesPerContractDescription: "Saisissez le nombre d'actions par contrat si applicable. Ceci est pertinent pour les transactions d'investissement ou les contrats impliquant des actions.",
      subAccountFund: "Fonds de sous-compte",
      subAccountFundDescription: "Saisissez le fonds de sous-compte si applicable.",
      securityId: "ID de sécurité",
      securityIdDescription: "Saisissez l'ID de sécurité si applicable.",
      securityIdType: "Type d'ID de sécurité",
      securityIdTypeDescription: "Saisissez le type d'ID de sécurité si applicable.",
      saveTransaction: "Enregistrer la transaction"
    },
    multiActionText: {
      selectAll: 'Tout sélectionner',
      deselectAll: 'Tout désélectionner',
      deleteSelected: 'Supprimer la sélection',
    },
    communicationResponse: {
      failedToLoad: 'Échec du chargement',
      emailError: 'Impossible de récupérer les réponses par e-mail. Veuillez réessayer plus tard.',
      smsError: 'Impossible de récupérer les réponses SMS. Veuillez réessayer plus tard.',
    },
    interactionHistory: {
      historyInteraction: "Historique des interactions",
      lastContacted: "Dernier contact",
      notesLastContacted: "Note",
      nextFollowUp: "Prochain suivi",
      notesNextFollowUp: "Note",
      preferredContactTime: "Heure de contact préférée",
      preferredContactToTime: "À",
      notesContactToTime: "Note",
      noHistory: "Aucun historique"
    },    
    imenuPayFlex:{
      invoiceId: "ID de facture",
      planName: "Nom du plan",
      amount: "Montant",
      totalAmount: "Montant total",
      subscription: "Abonnement",
      schedulePayment: "Calendrier de paiement",
      recurringPayment: "Paiement récurrent ?",
      frequency: "Fréquence",
      payEvery: "Payer tous les",
      customInterval: "Intervalle personnalisé",
      customIntervalNote: "Le paiement sera effectué tous les {days} jours",
      payStartsOn: "Le paiement commence le",
      payUntil: "Payer jusqu'au",
      endsAfterDate: "Le paiement se termine après",
      endsAfterOccurrences: "Le paiement se termine après {count} occurrences",
      howToPay: "Comment souhaitez-vous payer ?",
      creditCard: "Carte de crédit",
      banking: "Banque",
      placeholderCustomInterval: "2",
      placeholderOccurrences: "Exemple : 2",
    },
    googleCalendar: {
      createEvent: "Créer un événement",
      title: "Titre",
      description: "Description",
      location: "Lieu",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      timeZone: "Fuseau horaire",
      selectTimeZone: "Sélectionner un fuseau horaire",
      attendeeEmail: "E-mail du participant",
      attendeeEmailPlaceholder: "client@exemple.com",
      attendeeEmailLabel: "E-mail du participant",
      addAttendee: "Ajouter un participant",
      providerEmail: "E-mail du fournisseur",
      providerEmailPlaceholder: "fournisseur@exemple.com",
      color: "Couleur",
      selectColor: "Sélectionner une couleur",
      submitEvent: "Créer l'événement",
      updateEvent: "Mettre à jour l'événement",
      upcomingEvents: "Événements à venir",
      deleteConfirmationTitle: "Êtes-vous sûr ?",
      deleteConfirmationText: "Vous ne pourrez pas annuler cette action !",
      deleteNotificationCheckbox: "Souhaitez-vous les informer que l'événement est annulé ?",
      deleteConfirmButton: "Oui, supprimer !",
      deleteCancelButton: "Annuler",
      deleteSuccessTitle: "Supprimé !",
      deleteSuccessText: "L'événement a été supprimé.",
      deleteErrorTitle: "Erreur !",
      deleteErrorText: "Impossible de supprimer l'événement."
    },        
    bulkSend: {
      title: "Qu'est-ce que l'envoi groupé ?",
      text: "L'envoi groupé vous permet d'envoyer plusieurs e-mails et SMS à la fois, rendant la communication plus efficace.",
      confirmButtonText: "Compris !",
      selectRecipientsTitle: "Sélectionner les destinataires",
      selectAllCustomers: "Sélectionner tous les clients",
      selectAllSubscribers: "Sélectionner tous les abonnés",
      bulkSendOptionsTitle: "Options d'envoi groupé",
      sendEmail: "Envoyer un e-mail groupé",
      sendSMS: "Envoyer un SMS groupé",
      whenToSend: "Quand souhaitez-vous l'envoyer ?",
      sendNow: "Envoyer maintenant",
      schedule: "Planifier",
      cancel: "Annuler",
      validationSelectMethod: "Veuillez sélectionner au moins une méthode.",
      validationScheduledTime: "L'heure planifiée doit être dans le futur.",
      successSent: "Envoyé avec succès !",
      successScheduled: "Planifié avec succès !",
      error: "Une erreur est survenue.",
      subject: "Notification groupée",
      body: "Votre contenu de message planifié ici.",
      bulkSend:"Envoi groupé",
      validationSelectRecipients: "Sélectionnez au moins un destinataire"
    },      
    table: {
      transactionDate: 'Date de transaction',
      customerId: 'ID client',
      status: 'Statut',
      debit: 'Débit',
      credit: 'Crédit',
      description: 'Description',
      memo: 'Mémo',
      payee: 'Bénéficiaire',
      category: 'Catégorie',
      bestRepresentation: 'Meilleure représentation',
      country: 'Pays',
      action: 'Action'
    },
    emailTest: {
      sendTest: 'Envoyer un e-mail test',
      message: "Ceci est un message exemple. Merci de ne pas répondre à ce message.",
      subject: 'Assistance iMenuApps®',
      success: 'L\'e-mail a été envoyé avec succès.'
    },
    menu: {
      transactionData: 'Données de transaction',
      bankAccountConnection: 'Connexion au compte bancaire',
      viewTransactions: 'Voir les transactions',
      validationPhone: 'Le numéro de téléphone doit contenir exactement 10 chiffres.',
      restaurantAdministration: 'Admin',
      savedSuccesful: 'Le paramètre a été modifié avec succès',
      savedFailed: 'Une erreur est survenue lors de l\'enregistrement des paramètres.',
      lostChanges: 'Vos modifications seront perdues si vous quittez cette page !',
      sure: 'Êtes-vous sûr ?',
      wontRevert: "Vous ne pourrez pas annuler cette action !",
      yesVoid: 'Oui, annuler le paiement !',
      voided: 'Annulé !',
      voidedSuccessfully: 'Le paiement a été annulé avec succès.',
      yesRefund: 'Oui, rembourser !',
      refund: 'Remboursé !',
      refundSuccessfully: 'Le remboursement a été traité avec succès.',
      merchantQuoteNotes: 'Notes des devis marchands',
      merchantInvoiceNotes: 'Notes des factures marchandes',
      titleInformationIncomplete: 'Informations requises',
      informationIncomplete: 'Veuillez compléter tous les champs obligatoires.',
      yes: 'Oui',
      emailSend: 'E-mail envoyé',
      emailSendTo: 'L\'e-mail avec la facture a été envoyé correctement à',
      questionSendEmail: 'Envoyer un e-mail ?',
      dialogSendEmail: 'Êtes-vous sûr de vouloir envoyer l\'e-mail à',
      addNewSendEmail: 'Ajouter une autre adresse e-mail',
      send: 'Envoyer',
      close: 'Fermer',
      alertEmailSend: 'E-mail envoyé',
      alertEmailSendTo: 'Envoyé avec succès à',
      session: 'Session',
      foodServices: 'Produits/Services',
      ordersTickets: 'Commandes/Tickets',
      reservationsDeliveries: 'Réservations/Livraisons',
      restaurantAdministration: 'Administration',
      report: 'Rapports',
      sales: 'Ventes',
      staffOccupationsCustomersDrivers: 'Personnel/Métiers/Clients/Livreurs',
      marketing: 'Marketing',
      settings: 'Paramètres',
      merchantSettings: 'Paramètres marchands',
      revenue: 'Revenu',
      revenueInfo:
        'La section Revenu dans iMenuApps® est votre centre pour gérer toutes les activités génératrices de revenus au sein de votre entreprise. Cette section vous permet de gérer efficacement diverses tâches liées aux revenus et transactions financières, garantissant que vos opérations commerciales sont fluides et rentables. Voici ce que vous pouvez faire dans la section Revenu : 1. Voir/Créer des commandes : Gérez les commandes clients de la création à la finalisation. 2. Réservations : Gérez et suivez les réservations pour vos services. 3. Devis : Créez et gérez des devis pour des revenus potentiels. 4. Factures : Générez, gérez et suivez toutes les factures clients. 5. Livraison : Coordonnez et gérez les détails d\'expédition. 6. Suivi des expéditions : Surveillez l\'état des expéditions en temps réel. 7. Facturation d\'abonnement : Gérez la facturation récurrente. 8. Livraisons : Supervisez toutes les activités de livraison. 9. Demandes de retrait : Gérez les demandes de retrait des clients.',
      adminInfo:
        'La section Administration dans iMenuApps® sert de centre de contrôle pour gérer divers aspects opérationnels et logistiques de votre entreprise. Voici un aperçu des fonctionnalités que vous pouvez gérer : 1. Gestion des tables 2. Gestion des taxes 3. Gestion des livraisons 4. Gestion du personnel 5. Gestion des livreurs 6. Rôles et permissions 7. Gestion des feuilles de temps 8. Gestion des métiers 9. Gestion des clients 10. Gestion des crédits 11. Gestion des menus 12. Gestion des catégories 13. Gestion des produits 14. Générateur de codes-barres 15. Gestion des services 16. Autres frais 17. Prix spéciaux 18. Gestion des abonnés 19. eMarketing',
      imenuBookInfo:
        'La section iMenuBooks est votre hub complet de comptabilité et de gestion financière. Cette zone vous permet de gérer les transactions, de connecter des comptes bancaires et de maintenir un registre clair et précis de vos activités financières.',
      reportsInfo:
        'La section Rapports est votre centre pour accéder et analyser les performances et données financières de votre entreprise. Cette section vous fournit divers outils et rapports pour vous aider à prendre des décisions éclairées.',
      configInfo:
        'La section Paramètres marchands vous permet de configurer divers aspects essentiels de vos opérations commerciales. Cette section comprend : 1. Paramètres généraux 2. Fonctionnalités 3. Paramètres de conception 4. Sauvegarde et gestion des appareils',
      selections: 'Menus',
      productManagement: 'Gestion des produits'
    },
    controlPanel: {
      googleCalendar: 'Calendrier Google',
      notificationCenter: 'Centre de notifications',
      notificationBell: 'Cloche de notification',
      salesByCustomers: 'Ventes par clients',
      salesByProducts: 'Ventes par produits',
      dynamicReport: 'Rapport dynamique',
      events: "Créer des événements",
      eventTitle: "Événements",
      transactionData: 'Ajouter et modifier des transactions financières',
      bankConnect: 'Ajouter des comptes bancaires et cartes de crédit',
      viewTransaction: 'Ajouter/Modifier/Voir vos transactions',
      subscription: 'Voir et créer des abonnements et facturations (Terminal virtuel)',
      staff: 'Création de comptes utilisateurs pour les employés',
      occupations: 'Gestion des métiers. Les métiers sont liés aux membres du personnel.',
      roles: 'Gestion des rôles. Les rôles établissent les permissions dans les différentes zones de l\'application.',
      workSheet: 'Feuille de temps. Permet le contrôle du temps de travail du personnel.',
      customers: 'Affiche une liste des clients de l\'entreprise.',
      categories: 'Gérez les différentes catégories des menus.',
      menuItems: 'Gestion des articles/produits/services.',
      services: 'Gestion des services utilisés dans les menus traiteur.',
      menus: 'Gestion des menus. Un menu est composé de diverses catégories.',
      orders: 'Voir et créer des commandes',
      invoices: 'Voir et créer des factures',
      quotes: 'Voir et créer des devis',
      cateringOrders: 'Affiche les commandes traiteur.',
      orderForDelivery: 'Affiche les commandes prêtes à être livrées.',
      tickets: 'Permet la création et le suivi des tickets.',
      otherCharges: 'Gestion des frais supplémentaires.',
      taxes: 'Gestion des taxes. Voir et créer des taux de taxe.',
      deliveries: 'Gestion des prix de livraison.',
      reservations: 'Gérer et créer des réservations et listes d\'attente',
      tables: 'Gestion des capacités de l\'entreprise.',
      payments: 'Affiche la liste des transactions de paiement.',
      aboutSettings: 'Gestion du diaporama de la page d\'accueil.',
      paymentSettings: 'Configuration de la passerelle de paiement.',
      basicSettings: 'Configuration des données principales de l\'entreprise.',
      funtionalitiesSettings: 'Configuration du fonctionnement général de l\'entreprise.',
      colorSettings: 'Configuration des couleurs de l\'application.',
      systemSettings: 'Configuration de l\'intégration avec des applications tierces.',
      driver: 'Gestion des livreurs externes',
      credit: 'Gestion des crédits.'
    },
    options: {
      sameAsBilling: 'Identique à',
      contactPerson: 'Personne à contacter',
      email: 'E-mail',
      aditionalDetails: 'Détails supplémentaires',
      street: 'Rue',
      text: 'Un problème est survenu lors de la définition de l\'adresse par défaut.',
      updateAddress: 'Adresse mise à jour',
      wrongAddress: 'Un problème est survenu lors de la mise à jour de l\'adresse par défaut',
      billingAddress: 'Adresse de facturation',
      shippingAddress: 'Adresse de livraison',
      placeholderNotes: 'Écrivez vos notes ici',
      dataRequired: 'Données requises',
      customerArea: 'Zone client',
      customerName: 'Nom du client',
      customerEmail: 'E-mail du client',
      customerPhone: 'Téléphone du client',
      customerAddress: 'Adresse du client',
      terms: 'Conditions',
      trackingN: 'N° de suivi',
      shippingDate: 'Date d\'expédition',
      shippingTo: 'Livrer à',
      footer: 'Modifiez le pied de page pour votre module de revenu',
      ivoiceDate: 'Date de facture',
      quoteDate: 'Date du devis',
      subscriptionBilling: 'Facturation d\'abonnement',
      driverDeliveries: 'Livraisons',
      activeDriverOrder: 'Commandes actives',
      completedDriverOrder: 'Commandes terminées',
      useDirection: 'Cliquez si identique à l\'adresse de facturation',
      menuTitle: 'ADMINISTRATION',
      login: 'Connexion',
      logout: 'Déconnexion',
      controlPanel: 'Panneau de contrôle',
      adminSettings: 'Paramètres administrateur',
      supportPanel: 'Support',
      manageMenus: 'Menus',
      managePyments: 'Paiements',
      manageHouseAccount: 'Compte maison',
      viewOrders: 'Voir/Créer des commandes',
      viewQuotes: 'Devis',
      viewInvoice: 'Factures',
      manageCategories: 'Catégories',
      manageProducts: 'Articles',
      manageServices: 'Services',
      manageCustomers: 'Clients',
      manageCredits: 'Crédits',
      manageTables: 'Tables',
      manageTaxes: 'Taxes',
      manageShippings: 'Prix de livraison',
      manageOtherCharges: 'Autres frais',
      manageUsers: 'Personnel',
      manageDriver: 'Livreurs',
      manageRoles: 'Rôles/Permissions',
      manageWorkSheet: 'Feuille de temps',
      manageBasicSettings: 'Entreprise',
      manageRestaurantSettings: 'Paramètres de l\'entreprise',
      manageAboutSettings: 'Diapositives "À propos"',
      manageFunSettings: 'Fonctionnalités',
      manageColourSettings: 'Couleurs',
      manageDesign: 'Design',
      manageMore: 'Plus',
      managePaymentSettings: 'Paiements',
      manageOccupation: 'Métiers',
      manageKeySettings: 'Systèmes externes',
      supportSettings: 'Paramètres de support',
      changeServerId: 'Changer l\'ID employé',
      serverId: 'Code employé',
      manageVariantGroup: 'Choix',
      manageReservation: 'Réservations',
      manageWaitList: 'Liste d\'attente',
      viewCateringOrders: 'Commandes traiteur',
      forgotPassword: 'Mot de passe oublié ?',
      sendNewPassword: 'Envoyer un nouveau mot de passe',
      serverIdMessage: 'Ceci est le code de sécurité qui vous a été attribué lors de la création de votre profil',
      recoveryPassword: 'Récupération du mot de passe',
      refund: 'Remboursement',
      void: 'Annuler'
    },
    titles: {
      technology: "Technologie",
      retail: "Commerce de détail",
      healthcare: "Santé",
      finance: "Finance",
      retailGeneralMerchandise: "Commerce de détail (Articles divers)",
      healthcareServices: "Services de santé",
      foodAndBeverage: "Restauration (Restaurants, Cafés, Bars)",
      construction: "Construction",
      eCommerce: "Commerce électronique",
      informationTechnology: "Technologies de l'information (Services informatiques et développement logiciel)",
      realEstate: "Immobilier (Résidentiel et commercial)",
      transportationLogistics: "Transport et logistique",
      professionalServices: "Services professionnels (Conseil, Juridique, Comptabilité)",
      manufacturing: "Fabrication (Générale et spécialisée)",
      educationTraining: "Services d'éducation et de formation",
      entertainmentMedia: "Divertissement et médias",
      financialServices: "Services financiers (Banques, Sociétés d'investissement)",
      personalCareServices: "Services de soins personnels (Salons, Spas)",
      hospitality: "Hôtellerie (Hôtels, Agences de voyage)",
      insuranceAgencies: "Agences d'assurance",
      homeImprovementRepair: "Rénovation et réparation domiciliaire",
      automotiveServices: "Services automobiles (Réparation, Concessionnaires, Carrosseries)",
      telecommunications: "Télécommunications",
      nonprofitSocialServices: "Organismes sans but lucratif et services sociaux",
      agricultureFarming: "Agriculture",
      pharmaceuticalsBiotechnology: "Pharmaceutique et biotechnologie",
      energy: "Énergie (Renouvelable et non renouvelable)",
      sportsRecreation: "Sports et loisirs",
      fitnessWellness: "Fitness et bien-être",
      marketingAdvertising: "Marketing et publicité",
      eventPlanning: "Planification d'événements et services",
      cleaningServices: "Services de nettoyage (Résidentiel et commercial)",
      fashionApparel: "Mode et habillement",
      foodProductionProcessing: "Production et transformation alimentaire",
      petServices: "Services pour animaux (Toilettage, Pension, Vétérinaire)",
      artsCrafts: "Arts et artisanat (Services créatifs)",
      aerospaceDefense: "Aérospatiale et défense",
      environmentalServices: "Services environnementaux",
      technologyHardwareElectronics: "Matériel informatique et électronique",
      childcareServices: "Services de garde d'enfants",
      securityServices: "Services de sécurité (Cybersécurité, Sécurité physique)",
      publishing: "Édition (Livres, Magazines, Médias numériques)",
      transportationEquipmentManufacturing: "Fabrication d'équipements de transport",
      architectureDesign: "Architecture et design",
      accountingTaxPreparation: "Comptabilité et préparation des taxes",
      landscapingGardening: "Aménagement paysager et jardinage",
      beverageProduction: "Production de boissons (Bière artisanale, Vin, Spiritueux)",
      medicalDevicesSupplies: "Dispositifs et fournitures médicales",
      warehousingStorage: "Entreposage",
      freelancing: "Freelance (Rédaction, Design graphique, Programmation)",
      tourismAdventureServices: "Services de tourisme et d'aventure",
      utilitiesPublicServices: "Services publics",
      blockchainCryptocurrency: "Blockchain et cryptomonnaie",
      specializedRetail: "Commerce de détail spécialisé (Produits et services de niche)",
      eventPlanningServices: "Services de planification d'événements",
      transportationEquipment: "Fabrication d'équipements de transport",
      accountingTax: "Comptabilité et préparation des taxes",
      tourismAdventure: "Services de tourisme et d'aventure",
      shareViaEmailAndSMS: 'Partager par e-mail et SMS',
      sendEmail: 'Envoyer un e-mail',
      sendSMS: 'Envoyer un SMS',
      send: "Envoyer",
      sendNow: 'Envoyer maintenant',
      schedule: 'Planifier',
      cancel: 'Annuler',
      searchCustomer: 'Rechercher un client ou abonné',
      emailPlaceholder: 'E-mail',
      phonePlaceholder: 'Numéro de téléphone',
      sendByEmailAndSMS: 'Envoyer par e-mail et SMS',
      textSend: 'Vous pouvez ajouter plusieurs adresses e-mail en les séparant par une virgule',
      sendNotification: 'Vous êtes sur le point d\'envoyer cette notification à :',
      whenToSend: 'Quand souhaitez-vous l\'envoyer ?',
      bankAccountName: 'Nom du compte bancaire',
      routeNumber: 'Numéro de route',
      accountNumber: 'Numéro de compte',
      bankAccountAddress: 'Adresse du compte bancaire',
      nameAuthorizedPerson: 'Nom de la personne autorisée',
      paymentAmount: 'Montant du paiement',
      mustBe: 'Doit contenir 9 chiffres',
      warning: 'Avertissement',
      messageChangeQuote: 'Si vous changez ce préfixe, la numérotation de vos devis changera',
      messageChangeIvoice: 'Si vous changez ce préfixe, la numérotation de vos factures changera',
      messageStartingInvoiceNumber: 'Si vous changez ce numéro de départ, la numérotation de vos factures recommencera à partir de ce numéro.',
      prefixQuotes: 'Préfixe pour les devis (ex. QTE)',
      prefixInvoices: 'Préfixe pour les factures (ex. INV)',
      invoiceStartingNumber: 'Numéro de départ des factures',
      moneyNotEnought: 'Le montant doit être supérieur au total pour obtenir un changement',
      controlPanel: 'Panneau de contrôle',
      supportPanel: 'Support',
      menus: 'Menus',
      orders: 'Commandes',
      quotes: 'Devis',
      invoices: 'Factures',
      allOrders: 'Toutes les commandes',
      customerCredit: 'Crédit client',
      workSheet: 'Feuille de temps',
      cateringOrders: 'Commandes traiteur',
      ordersForDelivery: 'Commandes à livrer',
      suscriptors: 'Abonnés',
      tickets: 'Tickets de commande',
      categories: 'Catégories',
      products: 'Articles',
      customers: 'Clients',
      tables: 'Tables',
      taxes: 'Taxes',
      shippings: 'Prix de livraison',
      otherCharges: 'Autres frais',
      newsletter: 'Newsletter',
      users: 'Personnel',
      suscriptor: 'Abonnés',
      createCustomer:"Créer un client",
      communicationResponse: 'Réponse de communication',
      smsResposes: "Réponses SMS",
      emailResponses: "Réponses e-mail",
      loadingEmailResponses: "Chargement des réponses e-mail...",
      loadingSmsResponses: "Chargement des réponses SMS...",
      perPage: "Par page",
      emailNoSent: "E-mail non envoyé",
      noEmailResponses: "Aucune réponse e-mail",
      noEmailFound: "Aucune réponse e-mail trouvée pour votre compte",
      noSmsResponses: "Aucune réponse SMS",
      noSmsFound: "Aucune réponse SMS trouvée pour votre compte",
      createSubscriptor: "Créer un abonné",
      occupation: 'Métier',
      roles: 'Rôles',
      about: 'Diapositives "À propos"',
      digitalScreens: 'Écrans numériques',
      editAboutForm: 'Modifier la diapositive "À propos"',
      newAboutForm: 'Créer une nouvelle diapositive "À propos"',
      editDisplayForm: 'Modifier la diapositive d\'affichage numérique',
      newDisplayForm: 'Créer une diapositive d\'affichage numérique',
      basicConfig: 'Config. de base',
      functions: 'Fonctionnalités',
      colors: 'Couleurs',
      variantGroup: 'Choix',
      loading: 'Veuillez patienter...',
      editColorSetting: 'Modifier la couleur',
      createColorSetting: 'Créer une couleur',
      orderCateringForm: 'Modifier la commande traiteur',
      deliveryLocation: 'Lieu de livraison',
      cateringMenus: 'Menus traiteur',
      payments: 'Paiements',
      ticketDetails: 'Détails du ticket',
      emptyResult: 'Résultat vide',
      cancellationType: 'Type d\'annulation',
      changePassword: 'Changer le mot de passe',
      restaurantName: 'Nom de l\'entreprise',
      clockinClockout: 'Pointage - Dépointage',
      clockin: 'Pointer',
      clockout: 'Dépointer',
      timecard: 'Fiche de temps',
      timesheet: 'Feuille de temps',
      addContact: 'Ajouter un contact',
      updateContact: 'Mettre à jour le contact',
      contacts: 'Contacts',
      staff: 'Personnel'
    },
    placeholder: {
      contactNotFound: 'Contact non trouvé'
    },
    orderState: {
      started: 'commencé',
      inKitchen: 'en cuisine',
      cooked: 'cuit',
      delivering: 'livraison en attente',
      delivered: 'livré'
    },
    list: {
      buttons: {
        goToControlPanel: 'Aller à la gestion'
      },
      actions: {
        addANew: 'Ajouter un nouveau',
        edit: 'Modifier',
        delete: 'Supprimer',
        view: 'Voir'
      },
      entitiesName: {
        menu: 'menu',
        category: 'catégorie',
        categoryPlaceholder: 'Sélectionner une catégorie',
        product: 'article',
        customer: 'client',
        table: 'table',
        tax: 'taxe',
        taxPlaceholder: 'Sélectionner une taxe',
        shipping: 'livraison',
        trackShipping: "Suivre l'expédition",
        packagesManagement: 'Gestion des Paquets',
        otherCharge: 'autre frais',
        user: 'utilisateur',
        order: 'commande',
        role: 'rôle',
        about: 'à propos'
      },
      messages: {
        confirmDelete: 'Confirmer la suppression',
        confirmAccept: 'Confirmer l\'article',
        confirmProduct: 'Voulez-vous accepter cet article?',
        deleteCategory: 'Voulez-vous supprimer cette catégorie?',
        deleteRestaurant: 'Voulez-vous supprimer cette entreprise?',
        deleteOrder: 'Voulez-vous supprimer cette commande?',
        deleteCredit: 'Voulez-vous supprimer ce crédit?',
        deleteWorkSheet: 'Voulez-vous supprimer cette feuille de travail?',
        deleteCustomer: 'Voulez-vous supprimer ce client?',
        deleteMenu: 'Voulez-vous supprimer ce menu?',
        deleteOtherCharge: 'Voulez-vous supprimer cet autre frais?',
        deleteNewsletter: 'Voulez-vous supprimer cette newsletter?',
        deleteProduct: 'Voulez-vous supprimer cet article?',
        deleteShipping: 'Voulez-vous supprimer cette livraison?',
        deleteTable: 'Voulez-vous supprimer cette table?',
        deleteTax: 'Voulez-vous supprimer cette taxe?',
        deleteUser: 'Voulez-vous supprimer cet utilisateur?',
        deleteSuscriptor: 'Voulez-vous supprimer cet abonné?',
        deleteRole: 'Voulez-vous supprimer ce rôle?',
        deleteAbout: 'Voulez-vous supprimer cette information?',
        deleteDisplay: 'Voulez-vous supprimer cette publicité?',
        deleteOccupation: 'Voulez-vous supprimer cette profession?',
        deleteVariantGroup: 'Voulez-vous supprimer ces choix?',
        infoDeleteSuccess: 'Information',
        invalidCode: 'Code invalide, veuillez réessayer.',
        messageDeleteSuccessCategory: 'La catégorie a été supprimée avec succès',
        messageDeleteSuccessRestaurant: 'L\'entreprise a été supprimée avec succès',
        messageDeleteSuccessOrder: 'La commande a été supprimée avec succès',
        messageDeleteSuccessCredit: 'Le crédit a été supprimé avec succès',
        messageDeleteSuccessWorkSheet: 'La feuille de travail a été supprimée avec succès',
        messageDeleteSuccessCustomer: 'Le client a été supprimé avec succès',
        messageDeleteSuccessMenu: 'Le menu a été supprimé avec succès',
        messageDeleteSuccessOtherCharges: 'Les autres frais ont été supprimés avec succès',
        messageDeleteSuccessNewsletter: 'La newsletter a été supprimée avec succès',
        messageDeleteSuccessProduct: 'L\'article a été supprimé avec succès',
        messageDeleteSuccessShipping: 'La livraison a été supprimée avec succès',
        messageDeleteSuccessTable: 'La table a été supprimée avec succès',
        messageDeleteSuccessTax: 'La taxe a été supprimée avec succès',
        messageDeleteSuccessUser: 'L\'utilisateur a été supprimé avec succès',
        messageDeleteSuccessSuscriptor: 'L\'abonné a été supprimé avec succès',
        messageActivareSuccessSuscriptor: 'L\'abonné a été activé avec succès',
        messageDesactivareSuccessSuscriptor: 'L\'abonné a été désactivé avec succès',
        messageDeleteSuccessRole: 'Le rôle a été supprimé avec succès',
        messageDeleteSuccessAbout: 'L\'information a été supprimée avec succès',
        messageDeleteSuccessOccupation: 'La profession a été supprimée avec succès',
        messageDeleteSuccessVariantGroup: 'Les choix ont été supprimés avec succès',
        messageCateringApproved: 'La commande de traiteur a été approuvée avec succès',
        messageCateringCancelled: 'La commande de traiteur a été annulée avec succès',
        titleEditCategory: 'Modifier la catégorie',
        titleEditCustomer: 'Modifier le client',
        titleEditMenu: 'Modifier le menu',
        titleEditOtherCharges: 'Modifier les autres frais',
        titleEditProduct: 'Modifier l\'article',
        titleEditShipping: 'Modifier la livraison',
        titleEditTable: 'Modifier la table',
        titleEditTax: 'Modifier la taxe',
        titleEditUser: 'Modifier l\'utilisateur',
        titleEditRole: 'Modifier le rôle',
        titleEditSetting: 'Modifier les paramètres',
        titleEditOccupation: 'Modifier la profession',
        titleCreateCategory: 'Créer une catégorie',
        titleCreateCustomer: 'Créer un client',
        titleCreateMenu: 'Créer un menu',
        titleCreateOtherCharges: 'Créer d\'autres frais',
        titleCreateProduct: 'Créer un article',
        titleCreateShipping: 'Créer une livraison',
        titleCreateTable: 'Créer une table',
        titleCreateTax: 'Créer une taxe',
        titleCreateUser: 'Créer un utilisateur',
        titleCreateRole: 'Créer un rôle',
        titleCreateSetting: 'Créer des paramètres',
        titleCreateOccupation: 'Créer une profession',
        titleEditVariantGroup: 'Modifier les choix',
        titleCreateVariantGroup: 'Créer de nouveaux choix',
        messageEditSuccessCategory: 'La catégorie a été modifiée avec succès',
        messageEditSuccessCredit: 'Le crédit a été modifié avec succès',
        messageEditSuccessCustomer: 'Le client a été modifié avec succès',
        messageEditSuccessMenu: 'Le menu a été modifié avec succès',
        messageEditSuccessWorksheet: 'La feuille de travail a été modifiée avec succès',
        messageEditSuccessOtherCharges: 'Les autres frais ont été modifiés avec succès',
        messageEditSuccessProduct: 'L\'article a été modifié avec succès',
        messageEditSuccessShipping: 'La livraison a été modifiée avec succès',
        messageEditSuccessTable: 'La table a été modifiée avec succès',
        messageEditSuccessTax: 'La taxe a été modifiée avec succès',
        messageEditSuccessUser: 'L\'utilisateur a été modifié avec succès',
        messageEditSuccessSuscriptor: 'L\'abonné a été modifié avec succès',
        messageEditSuccesRole: 'Le rôle a été modifié avec succès',
        messageEditSuccessSetting: 'Les paramètres ont été modifiés avec succès',
        messageEditSuccessOccupation: 'La profession a été modifiée avec succès',
        messageEditSuccessVariantGroup: 'Les choix ont été modifiés avec succès',
        messageDeleteSuccessVariant: 'Les choix ont été supprimés avec succès',
        messageEditSuccessVariant: 'Les choix ont été modifiés avec succès',
        messageCreateSuccessVariant: 'Les choix ont été créés avec succès',
        messageCreateSuccessCategory: 'La catégorie a été créée avec succès',
        messageCreateSuccessCredit: 'Le crédit a été créé avec succès',
        messageCreateSuccessCustomer: 'Le client a été créé avec succès',
        messageCreateSuccessMenu: 'Le menu a été créé avec succès',
        messageCreateSuccessWorksheet: 'La feuille de travail a été créée avec succès',
        messageCreateSuccessOtherCharges: 'Les autres frais ont été créés avec succès',
        messageCreateSuccessProduct: 'L\'article a été créé avec succès',
        messageCreateSuccessShipping: 'La livraison a été créée avec succès',
        messageCreateSuccessTable: 'La table a été créée avec succès',
        messageCreateSuccessTax: 'La taxe a été créée avec succès',
        messageCreateSuccessUser: 'L\'utilisateur a été créé avec succès',
        messageCreateSuccessSuscriptor: 'L\'abonné a été créé avec succès',
        messageCreateSuccessRole: 'Le rôle a été créé avec succès',
        messageCreateSuccessSetting: 'Le paramètre a été créé avec succès',
        messageCreateSuccessOccupation: 'La profession a été créée avec succès',
        messageCreateSuccessVariantGroup: 'Les choix ont été créés avec succès',
        menuChangeState: 'L\'état du menu a été changé avec succès',
        activeMenu: 'Menu actif',
        otherChargeChangeState: 'L\'état des autres frais a été changé avec succès',
        activeOtherCharge: 'Autres frais actifs',
        taxChangeState: 'L\'état de la taxe a été changé avec succès',
        activeTax: 'Taxe active',
        shippingChangeState: 'L\'état de la livraison a été changé avec succès',
        activeShipping: 'Livraison active',
        deleteSubtitleCategory: 'Supprimer la catégorie',
        deleteSubtitleCustomer: 'Supprimer le client',
        deleteSubtitleMenu: 'Supprimer le menu',
        deleteSubtitleOtherCharges: 'Supprimer les autres frais',
        deleteSubtitleProduct: 'Supprimer l\'article',
        deleteSubtitleShipping: 'Supprimer la livraison',
        deleteSubtitleTable: 'Supprimer la table',
        deleteSubtitleTax: 'Supprimer la taxe',
        deleteSubtitleUser: 'Supprimer l\'utilisateur',
        deleteSubtitleRole: 'Supprimer le rôle',
        deleteSubtitleAbout: 'Supprimer l\'information',
        deleteSubtitleOccupation: 'Supprimer la profession',
        deleteSubtitleVariantGroup: 'Supprimer les choix',
        deleteAertMessage: 'Êtes-vous sûr de vouloir supprimer le contact.',
        errorTitle: 'Erreur',
        errorMessage: 'Quelque chose s\'est mal passé.',
        changeOrderStateMessage: 'Changer l\'état de la commande',
        changeOrderStateSuccess: 'L\'état de la commande a été changé avec succès',
        changeOrderStateCanceled: 'La commande a été annulée',
        connectionError: 'Erreur de connexion',
        sharedWorksheet: 'Feuille de travail partagée avec le membre du personnel',
        connectionErrorMessage: 'Il y a eu une erreur de connexion. Veuillez vérifier votre connexion Internet et réessayer. Si le problème persiste, contactez votre fournisseur de services.',
        newPasswordSent: 'Le nouveau mot de passe a été envoyé à votre email',
        emailOrPasswordIncorrect: 'Email ou mot de passe incorrect',
        buttons: {
          cancel: 'Annuler',
          delete: 'Supprimer',
          close: 'Fermer',
          goToAdministration: 'Aller à l\'administration',
          goToList: 'Aller à la liste',
          retry: 'Réessayer'
        }
      }
    },
    form: {
      includeMiddleName: 'Inclure le nom de la personne',
      login: 'Connexion',
      events: {
        backgroundImage: 'Image de fond',
        backgroundColor: 'Couleur de fond',
        backgroundColorSection: 'Ajouter une couleur de fond à cette section',
        backgroundColorDates: 'Couleur de fond pour les dates',
        backgroundColorTitle: 'Couleur de fond pour le titre',
        backgroundColorSubtitle: 'Couleur de fond pour le sous-titre',
        backgroundColorDescription: 'Couleur de fond pour la description',
        backgroundColorFooter: 'Couleur de fond pour le pied de page',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        startTime: 'Heure de début',
        endTime: 'Heure de fin',
        dates: 'Dates',
        title: 'Titre',
        subtitle: 'Sous-titre',
        description: 'Description',
        footer: 'Pied de page',
        saveToCalendar: 'Ajouter à Google Calendar'
      },
      colour: {
        primaryColor: 'Couleur primaire',
        primary: 'Primaire',
        primaryText: 'Texte primaire',
        secondaryColor: 'Couleur secondaire',
        secondary: 'Secondaire',
        secondaryText: 'Texte secondaire',
        tertiaryColor: 'Couleur tertiaire',
        tertiary: 'Tertiaire',
        tertiaryText: 'Texte tertiaire',
        successColor: 'Couleur de succès',
        success: 'Succès',
        successText: 'Texte de succès',
        dangerColor: 'Couleur de danger',
        danger: 'Danger',
        dangerText: 'Texte de danger',
        backgroundColor: 'Couleur de fond',
        background: 'Fond'
      },
      tableShape: {
        square: 'Carré',
        rectangular: 'Rectangulaire',
        circle: 'Cercle',
        oval: 'Ovale'
      },
      buttons: {
        backToCategoriesList: 'Retour à la liste des catégories',
        backToCustomersList: 'Retour à la liste des clients',
        backToMenusList: 'Retour à la liste des menus',
        backToOrdersList: 'Retour à la liste des commandes',
        backToOtherChargesList: 'Retour à la liste des autres frais',
        backToProductsList: 'Retour à la liste des articles',
        backToShippingsList: 'Retour à la liste des livraisons',
        backToTablesList: 'Retour à la liste des tables',
        backToTaxesList: 'Retour à la liste des taxes',
        backToUsersList: 'Retour à la liste des utilisateurs',
        backToRolesList: 'Retour à la liste des rôles',
        backToAboutList: 'Retour à la liste À propos',
        backToMenu: 'Retour au menu',
        cancelOrder: 'Annuler la commande',
        changeState: 'Changer l\'état en',
        defaultColor: 'Couleur par défaut',
        addChoice: 'Ajouter une variante',
        back: 'Retour',
        save: 'Enregistrer',
        submit: 'Soumettre',
        change: 'Changer',
        add: 'Ajouter',
        update: 'Mettre à jour'
      },
      titles: {
        identificationInformation: 'Informations d\'identification',
        idType: 'Type de pièce d\'identité',
        driverLicense: 'Permis de conduire',
        internationalId: 'Carte d\'identité internationale (Cédula)',
        nameLicense: 'Nom sur le permis',
        licenseNumber: 'Numéro de permis',
        issueDate: 'Date d\'émission',
        expirationDate: 'Date d\'expiration',
        sex: 'Sexe',
        dateBirth: 'Date de naissance',
        meters: 'Mètres',
        feet: 'Pieds',
        centimeters: 'Centimètres',
        inches: 'Pouces',
        height: 'Taille',
        nameId: 'Nom sur la pièce d\'identité',
        identificationNumber: 'Numéro d\'identification',
        nationality: 'Nationalité',
        martialStatus: 'Statut matrimonial',
        single: 'Célibataire',
        married: 'Marié(e)',
        divorced: 'Divorcé(e)',
        widowed: 'Veuf/Veuve',
        occupation: 'Profession',
        socialeMediaChannels: 'Canaux de médias sociaux',
        customerType: 'Type de client',
        customerStatus: 'Statut du client',
        gender: 'Genre',
        preferredContact: 'Méthode de contact préférée',
        enableAll: 'Tout activer',
        disableAll: 'Tout désactiver',
        invoiceReminderLabel: 'Entrez tous les combien de jours un rappel sera envoyé',
        invoiceReminder: 'Activer les rappels de facture',
        assetPickupRequest: 'Demande de ramassage d\'actif',
        pickupAddress: 'Adresse de ramassage',
        requireDeposit: 'Exiger un dépôt',
        lateFees: 'Activer les frais de retard',
        lateFeesLabel: 'Entrez le pourcentage d\'arriérés à collecter',
        thisInvoice: 'Cette facture a été PAYÉE',
        customerNewTitle: 'Créer un nouveau client',
        customerEditTitle: 'Modifier le client',
        categoryNewTitle: 'Créer une nouvelle catégorie',
        creditNewTitle: 'Créer un nouveau crédit',
        categoryEditTitle: 'Modifier la catégorie',
        creditEditTitle: 'Modifier le crédit',
        menuNewTitle: 'Créer un nouveau menu',
        workSheetNewTitle: 'Créer une feuille de travail',
        menuEditTitle: 'Modifier le menu',
        workSheetEditTitle: 'Modifier la feuille de travail',
        productNewTitle: 'Créer un article',
        serviceNewTitle: 'Créer un service',
        productEditTitle: 'Modifier l\'article',
        serviceEditTitle: 'Modifier le service',
        changePaymentSetting: 'Modifier les paramètres de paiement',
        shippingNewTitle: 'Créer un nouveau prix de livraison',
        shippingEditTitle: 'Modifier le prix de livraison',
        taxNewTitle: 'Créer une nouvelle taxe',
        taxEditTitle: 'Modifier la taxe',
        tableNewTitle: 'Créer une nouvelle table',
        tableEditTitle: 'Modifier la table',
        packageNewTitle: 'Créer un nouveau package',
        packageEditTitleditTitle: 'Modifier le package',
        variantGroupEditTitle: 'Modifier les choix',
        variantGroupNewTitle: 'Créer un nouveau choix',
        otherChargeNewTitle: 'Créer un autre frais',
        otherChargeEditTitle: 'Modifier les autres frais',
        userNewTitle: 'Créer un nouveau membre du personnel',
        suscriptionNewTitle: 'Créer un nouvel abonnement',
        driversNewTitle: 'Créer un nouveau chauffeur',
        userEditTitle: 'Modifier le membre du personnel',
        suscriptionEditTitle: 'Modifier l\'abonnement',
        driversEditTitle: 'Modifier le chauffeur',
        supportUsers: 'Utilisateurs de support',
        occupationNewTitle: 'Créer une nouvelle profession/emploi',
        occupationEditTitle: 'Modifier la profession/emploi',
        roleNewTitle: 'Ajouter des permissions',
        roleEditTitle: 'Modifier le rôle',
        selectAProduct: 'Sélectionner un article',
        selectACategory: 'Sélectionner une catégorie',
        selectACustomer: 'Sélectionner un client',
        selectATax: 'Sélectionner une taxe',
        selectARestaurant: 'Sélectionner une entreprise',
        selectAState: 'Sélectionner un état',
        filterCategory: 'Filtrer...',
        selectALanguage: 'Langue',
        selectAnOccupation: 'Sélectionner une profession',
        selectACooker: 'Sélectionner un cuisinier',
        selectADriver: 'Sélectionner un chauffeur',
        allProducts: 'Tous les articles:',
        settingEditTitle: 'Modifier les paramètres',
        settingNewTitle: 'Ajouter des paramètres',
        generalSettingEditTitle: 'Modifier les paramètres de base',
        generalSettingNewTitle: 'Ajouter des paramètres de base',
        keySettingEditTitle: 'Modifier les paramètres système',
        keySettingNewTitle: 'Créer des paramètres système',
        funSettingEditTitle: 'Paramètres des fonctionnalités',
        funSettingNewTitle: 'Créer des paramètres de fonctionnalités',
        pickFromSelect: 'Sélectionner le ramassage depuis',
        pickToSelect: 'Sélectionner le ramassage vers',
        dateFromSelect: 'Sélectionner la date de début',
        dateToSelect: 'Sélectionner la date de fin',
        cancelOrder: 'Annuler la commande',
        drivers: 'Chauffeurs',
        customer: 'Client',
        date: 'Date',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        orderType: 'Type de commande',
        addressToDelivery: 'Adresse de livraison',
        hourToPick: 'Heure de ramassage',
        tableService: 'Service à table',
        products: 'Articles',
        services: 'Services',
        otherCharges: 'Autres frais',
        shippingPrice: 'Prix de livraison',
        subtotal: 'Sous-total',
        tax: 'Total des taxes',
        tip: 'Pourboire',
        total: 'Total',
        number: 'Numéro',
        doYou: 'Voulez-vous vraiment supprimer',
        marked: 'les enregistrements marqués?',
        pendingPay: 'Paiement en attente',
        payed: 'Payé',
        notes: 'Notes',
        cancelNotes: 'Notes d\'annulation',
        pickupNotes: 'Notes de ramassage',
        cooker: 'Cuisinier',
        state: 'État',
        generalConfiguration: 'CONFIGURATIONS GÉNÉRALES',
        paymentConfiguration: 'CONFIGURATIONS DE PAIEMENT',
        cashDiscount: 'REMISE EN ESPÈCES',
        eposConfiguration: 'CONFIGURATION EPOS',
        emailConfiguration: 'CONFIGURATIONS D\'EMAIL',
        twilioSMS: 'Twilio SMS',
        sinchSMS: 'Sinch SMS',
        selectAVariantGroup: 'Sélectionner un choix',
        imageText: 'Pour de meilleurs résultats, veuillez télécharger une image de taille 750x750px. Assurez-vous d\'avoir les droits sur toute image téléchargée',
        orderCateringForm: 'Approbation de commande de traiteur',
        restaurantHours: 'Heures d\'ouverture',
        deadlinesNotes: 'Veuillez vous assurer que la somme des délais est de 100.',
        selectDate: 'Sélectionner une date',
        toPay: 'À payer',
        pending: 'En attente',
        genaral: 'Général',
        others: 'Autres',
        variants: 'Variantes',
        sides: 'Accompagnements',
        ingredients: 'Ingrédients',
        shift4: 'Shift4',
        auth: 'Authorize.Net',
        capcha: 'Captcha',
        zipCodes: 'Codes postaux',
        backups: 'Sauvegardes',
        devices: 'Appareils',
        creditSetting: 'Paramètre de crédit'
      },
      fields: {
        createNewCustomer: 'Créer un nouveau client',
        editItem: 'Modifier l\'article',
        previewInvoice: 'Aperçu de la facture',
        companyName: 'Nom de l\'entreprise',
        companyEmail: 'Email de l\'entreprise',
        companyPhone: 'Téléphone de l\'entreprise',
        companyTitle: 'Titre du poste',
        companyWebSite: 'Site web de l\'entreprise',
        companyIndustry: 'Secteur d\'activité',
        addNewCustomer: 'Ajouter un nouveau client',
        projectName: 'Nom du projet',
        billingAddress: 'Adresse de facturation',
        selectCustomerAttachBillingAddress: 'Sélectionner un client pour attacher une adresse de facturation',
        selectCustomerAttachShippingAddress: 'Sélectionner un client pour attacher une adresse de livraison',
        selectedAddress: 'Adresse sélectionnée:',
        changeAddress: 'Changer une',
        addAddress: 'Ajouter une',
        number: 'Numéro',
        shippingAddress: 'Adresse de livraison',
        username: 'Nom d\'utilisateur',
        emailLabel: 'Email',
        phoneLabel: 'Téléphone',
        firstNameLabel: 'Prénom',
        lastNameLabel: 'Nom',
        putEmail: 'Entrez votre email',
        putPhone: 'Entrez votre téléphone',
        putFirstName: 'Entrez votre prénom',
        putLastName: 'Entrez votre nom',
        putUserName: 'Entrez votre nom d\'utilisateur',
        takePicture: 'Prendre une photo',
        accept: 'Accepter',
        hidde: 'Masquer',
        delete: 'Supprimer',
        retake: 'Reprendre',
        previewPhoto: 'Aperçu de la photo',
        previewAcceptedPhoto: 'Aperçu de la photo acceptée',
        viewImenuBookControlPanel: 'Voir iMenuBooks sur le panneau de contrôle',
        viewImenuEngageControlPanel: 'Voir iMenuEngage360 sur le panneau de contrôle',
        viewImenuBookOptions: 'Voir les options iMenuBooks',
        viewOrdersOption: 'Voir l\'option Commande',
        viewReservationOption: 'Voir l\'option Réservation',
        viewInvoiceOption: 'Voir l\'option Facture',
        viewQuoteOption: 'Voir l\'option Devis',
        changeImage: 'Changer l\'image',
        addImage: 'Ajouter une image',
        customerHours: 'Heures d\'ouverture',
        to: 'À',
        subject: 'Sujet',
        message: 'Message',
        name: 'Nom',
        menuName: 'Nom du menu',
        description: 'Description',
        email: 'Email',
        password: 'Mot de passe',
        date: 'Date',
        image: 'Image',
        phone: 'Téléphone',
        productMin: 'Article min',
        productMax: 'Article max',
        price: 'Prix',
        extraCharge: 'Supplément',
        costPrice: 'Coût',
        retailPrice: 'Vente',
        stimateTime: 'Temps estimé (en minutes)',
        stockQuantity: 'Quantité en stock',
        minReorderPoint: 'Quantité de stock minimale',
        maxReorderPoint: 'Quantité de stock maximale',
        CreditAmount: 'Montant du crédit',
        vendorName: 'Nom du fournisseur',
        vendorCode: 'Code du fournisseur',
        shortDescription: 'Description courte',
        keywords: 'Mots-clés',
        tags: 'Tags',
        binNumber: 'Numéro de bac',
        addSerialNumber: 'Ajouter un numéro de série',
        active: 'Activer',
        save: 'Enregistrer',
        submitToken: 'Soumettre le token',
        available: 'Disponible',
        availableCategories: 'CATÉGORIES DISPONIBLES',
        availableProducts: 'ARTICLES DISPONIBLES',
        availableStaff: 'PERSONNEL DISPONIBLE',
        selectedProducts: 'ARTICLES SÉLECTIONNÉS',
        selectedCategories: 'CATÉGORIES SÉLECTIONNÉES',
        selectedStaff: 'PERSONNEL SÉLECTIONNÉ',
        workedHours: 'HEURES TRAVAILLÉES',
        scheduledDates: 'Dates programmées',
        selectedAggregates: 'AGRÉGATS SÉLECTIONNÉS',
        marketingConsent: 'CONSENTEMENT MARKETING',
        product: 'Article',
        category: 'Catégorie',
        tax: 'Taxe',
        parentCategory: 'Catégorie parente',
        qrCode: 'QR Code',
        capacity: 'Capacité',
        percent: 'Pourcentage',
        priority: 'Priorité (0 - 1)',
        permissions: 'Permissions',
        permissionsRole: 'Rôles de permission',
        selectCashDiscount: 'Sélectionner une remise en espèces',
        roles: 'Profession/Emploi',
        address: 'Adresse',
        title: 'Titre',
        subtitle: 'Sous-titre',
        online: 'En ligne',
        showOtherRestaurant: 'Afficher d\'autres entreprises',
        reservationByTable: 'Réserver une table',
        reservationByStaff: 'Réserver du personnel',
        tablesChoose: 'Le client peut choisir l\'emplacement de la table',
        onlineMss: 'L\'entreprise n\'est pas visible au public',
        onlineMss1: 'L\'entreprise est visible au public',
        mustClockinMss: 'Vous devez d\'abord pointer. Veuillez',
        mustClockin2Mss: 'pointer.',
        SelectPickHour: 'Sélectionner l\'heure de ramassage',
        SelectPickHour2: 'Activer l\'heure de ramassage',
        TipRequire: 'Exiger un pourboire',
        tips: 'Pourboires',
        assetPickup: 'Ramassage d\'actif',
        depositAmount: 'Montant du dépôt',
        typeTip: 'Taper un pourcentage de pourboire',
        MinTimeToCook: 'Temps minimum de cuisson',
        PickFrom: 'Ramassage à partir de',
        PickFromToolTip: 'Ajouter l\'heure de début de livraison',
        PickTo: 'Fin de l\'heure de ramassage',
        PickToToolTip: 'Ajouter l\'heure de fin de livraison',
        DateFrom: 'Date de début',
        DateTo: 'Date de fin',
        DateLimit: 'Date limite de paiement',
        ShowCooker: 'Afficher le cuisinier',
        zipCodes: 'Codes postaux',
        deliveryZone: 'Zones de livraison',
        cooker: 'Cuisinier',
        driver: 'Chauffeur',
        rejectedOrder: 'Commande rejetée par le chauffeur',
        cancelationNote: 'Note d\'annulation',
        tableNumber: 'Numéro de table',
        firstName: 'Prénom',
        lastName: 'Nom',
        occupation: 'Profession',
        confirmPassword: 'Confirmer le mot de passe',
        endPointUrl: 'URL du point de terminaison',
        capchaKey: 'Clé Captcha',
        clientGuid: 'GUID client',
        interfazVersion: 'Version de l\'interface',
        interfazName: 'Nom de l\'interface',
        apiLoginId: 'ID de connexion API',
        eposToken: 'Token ePos',
        epos: 'Intégrer avec ePos',
        transactionKey: 'Clé de transaction',
        smtpHost: 'Hôte SMTP',
        port: 'Port',
        secure: 'Sécurisé',
        twFromNumber: 'Numéro d\'expéditeur',
        twAccountSID: 'SID du compte',
        twToken: 'Token',
        sinchFromNumber: 'Numéro d\'expéditeur',
        sinchAccountSID: 'ID du plan de service',
        sinchToken: 'Token',
        web: 'Site web',
        variantGroup: 'Choix',
        haveSides: 'Accompagnements',
        cantOfSides: 'Nombre d\'accompagnements inclus',
        categoryOfSides: 'Filtrer les accompagnements par catégorie',
        addIngredients: 'Spécifier les ingrédients',
        typeAnIngredient: 'Taper un ingrédient',
        canViewGeoposition: 'Peut voir la géolocalisation',
        canViewRating: 'Peut voir l\'évaluation',
        viewDelivery: 'Peut créer des commandes de livraison',
        viewOnTable: 'Peut créer des commandes à table',
        viewCurbside: 'Peut créer des commandes en bordure de trottoir',
        tablePrefix: 'Préfixe de table',
        barPrefix: 'Préfixe de bar',
        roomPrefix: 'Préfixe de salle',
        typeZipCode: 'Entrer un code postal',
        isCatering: 'Est traiteur',
        isService: 'Menu service',
        isReservationMenu: 'Menu réservation',
        catering: 'Traiteur',
        minAmoutCatering: 'Montant minimum pour traiteur',
        minAmountCateringDelivery: 'Montant minimum pour livraison',
        loyaltyMinPointToBuy: 'Points minimum pour acheter',
        loyaltyExpirationMonths: 'Nombre de mois d\'expiration de la fidélité',
        loyaltyPointMoney: 'Nombre de points pour 1$',
        partialPay: 'Paiement partiel',
        payForQuotation: 'Prépaiement pour devis',
        percentPayForQuotation: 'Montant du prépaiement pour devis',
        service: 'Service',
        showServicePrice: 'Afficher le prix du service',
        viewCatering: 'Voir le traiteur',
        viewLoyalty: 'Voir le programme de fidélité',
        viewReservation: 'Voir la réservation',
        reservation: 'Réservation',
        loyalty: 'Programme de fidélité',
        minDayToReservation: 'Nombre minimum de jours pour réserver',
        viewCustomerReservation: 'Voir les réservations des clients',
        sameHourForAllDays: 'Même heure pour tous les jours',
        followingDays: 'Mêmes heures pour les jours suivants',
        timezone: 'Fuseau horaire',
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
        allDays: 'Tous les jours',
        marginDays: 'Nombre minimum de jours pour passer commande',
        cateringStates: 'États de traiteur',
        typeState: 'Entrer un code d\'état',
        zipCodesExclude: 'Codes postaux inclus',
        cateringEvents: 'Événement de traiteur',
        typeEventName: 'Entrer un nom d\'événement',
        proposeNewDataTime: 'Proposer une nouvelle date/heure',
        fixed: 'Montant fixe',
        amount: 'Montant',
        discount: 'Remise',
        deadlines: 'Délais',
        pendingPay: 'Paiement en attente',
        payed: 'Payé',
        states: 'États',
        paymentMethod: 'Méthode de paiement',
        cash: 'Espèces',
        card: 'Carte',
        check: 'Chèque',
        free: 'Libre',
        busy: 'Occupé',
        dirty: 'Sale',
        authenticationToken: 'Token d\'autorisation',
        authenticationTokenMoto: 'Token d\'autorisation MOTO',
        authenticationTokenFB: 'Token d\'autorisation F&B',
        accountType: 'Type de compte',
        method: 'Méthode',
        serverName: 'Nom du serveur',
        urlLocation: 'Emplacement URL',
        fax: 'Fax',
        oldServerId: 'Ancien ID employé',
        newServerId: 'Nouvel ID employé',
        acivateTwilio: 'Activer Twilio',
        acivateSinch: 'Activer Sinch',
        isDriver: 'Est un chauffeur',
        monthy: 'Mensuel',
        anual: 'Annuel',
        merchantOnboardingApplication: 'Application d\'intégration de marchand',
        applicationName: 'Nom de l\'application',
        agentId: 'ID de l\'agent',
        planId: 'ID du plan',
        dateOfBirth: 'Date de naissance',
        equityOwnershipPercent: 'Pourcentage de propriété des actions',
        isPersonalGuarantor: 'Est un garant personnel ?',
        bookablePackage: 'Forfait réservable',
        showProgressBar: 'Afficher la barre de progression au conducteur'
      },
      messages: {
        buttons: {
          ok: 'Ok',
          dismiss: 'Fermer'
        },
        activatePaymentMethod: 'a été activé.',
        incorrectToken: 'Le jeton envoyé est incorrect.',
        activationMethodError: 'La méthode d\'activation a renvoyé une erreur.',
        unexpectedError: 'Une erreur inattendue s\'est produite.',
        savePaymentMethodSuccess: 'Les paramètres du moyen de paiement ont été enregistrés.',
        savePaymentMethodError: 'Une erreur est survenue lors de l\'enregistrement des paramètres du moyen de paiement.'
      },
      validate: {
        emailExisteTitle: 'Email déjà existant',
        emailExistMessage: 'Cet email est déjà enregistré. Veuillez utiliser une autre adresse email ou demander à l\'utilisateur de cliquer sur "Mot de passe oublié" sur l\'écran de connexion.',
        validate: 'Valider',
        validateCategory: 'Valider la catégorie',
        validateCustomer: 'Valider le client',
        validateMenu: 'Valider le menu',
        validateOtherCharge: 'Valider les frais supplémentaires',
        validateProduct: 'Valider l\'article',
        validateShipping: 'Valider la livraison',
        validateTable: 'Valider la table',
        validateTax: 'Valider la taxe',
        validateUser: 'Valider l\'utilisateur',
        validateRole: 'Valider le rôle',
        validateSetting: 'Valider les paramètres',
        validateOccupation: 'Valider la profession',
        validateVariantGroup: 'Valider les options',
        name: 'Le nom est requis',
        image: 'L\'image est requise',
        email: 'L\'email est requis',
        phone: 'Le téléphone est requis',
        emailIncorrect: 'L\'email est incorrect',
        date: 'La date est requise',
        selectedCategories: 'Les catégories sélectionnées sont requises',
        productMinNumber: 'Le minimum d\'articles doit être un nombre',
        productMaxNumber: 'Le maximum d\'articles doit être un nombre',
        productMinGreater: 'Le minimum d\'articles doit être supérieur à 0',
        productMaxGreater: 'Le maximum d\'articles doit être supérieur à 2',
        price: 'Le prix doit être un nombre',
        priceGreater: 'Le prix doit être supérieur à 0',
        product: 'Vous devez sélectionner un article',
        costPriceNumber: 'Le prix de revient doit être un nombre',
        retailPriceNumber: 'Le prix de vente doit être un nombre',
        retailPriceShouldBeGreaterThanSalePrice: 'Le prix de détail doit toujours être supérieur au prix de vente',
        costPriceGreater: 'Le prix de revient doit être supérieur à 0',
        retailPriceGreater: 'Le prix de vente doit être supérieur à 0',
        category: 'Vous devez sélectionner une catégorie',
        capacity: 'La capacité doit être un nombre',
        capacityGreater: 'La capacité doit être supérieure à 0',
        percent: 'Le pourcentage doit être un nombre',
        percentGreater: 'Le pourcentage doit être supérieur à 0',
        password: 'Le mot de passe est requis',
        address: 'L\'adresse est requise',
        title: 'Le titre est requis',
        subtitle: 'Le sous-titre est requis',
        zipCode: 'Le code postal n\'est pas valide',
        duplicateZipCode: 'Code postal en double',
        cateringPriceZero: 'Le prix traiteur est zéro',
        cooker: 'Vous devez remplir le champ cuisinier',
        tableNumber: 'Le numéro de table doit être un nombre',
        tableNumberGreater: 'Le numéro de table doit être supérieur à 0',
        nameDuplicate: 'Il existe déjà une table avec ce nom. Vous devez changer le numéro ou le type.',
        firstName: 'Vous devez remplir le champ prénom',
        lastName: 'Vous devez remplir le champ nom',
        confirmPassword: 'Les champs mot de passe et confirmation du mot de passe doivent être identiques',
        occupation: 'Vous devez remplir le champ profession',
        notes: 'Vous devez remplir le champ note d\'annulation',
        tip: 'Le pourboire ne peut pas être zéro',
        tipRepeat: 'Le pourboire existe déjà. Veuillez saisir un nouveau montant.',
        emailDontExist: 'L\'email n\'existe pas.',
        ingredient: 'L\'ingrédient existe déjà.'
      },
      permissionsGroup: {
        permissionMenu: 'PERMISSIONS MENU',
        permissionCategory: 'PERMISSIONS CATÉGORIE',
        permissionProduct: 'PERMISSIONS ARTICLES',
        permissionSpecialPrice: 'PERMISSIONS PRIX SPÉCIAL',
        permissionCustomer: 'PERMISSIONS CLIENTS',
        permissionCredit: 'PERMISSIONS CRÉDITS',
        permissionHouseAccount: 'PERMISSIONS COMPTE MAISON',
        permissionTable: 'PERMISSIONS TABLES',
        permissionTax: 'PERMISSIONS TAXES',
        permissionShipping: 'PERMISSIONS LIVRAISONS',
        permissionOtherCharge: 'PERMISSIONS FRAIS SUPPLÉMENTAIRES',
        permissionUser: 'PERMISSIONS PERSONNEL',
        permissionDriver: 'PERMISSIONS SUPERVISION LIVREUR',
        permissionDeliveryDriver: 'PERMISSIONS LIVREURS',
        permissionOrder: 'PERMISSIONS COMMANDES',
        permissionRole: 'PERMISSIONS RÔLES',
        permissionWorkSheet: 'PERMISSIONS FEUILLE DE TRAVAIL',
        permissionSetting: 'PERMISSIONS PARAMÈTRES',
        permissionPayment: 'PERMISSIONS PAIEMENTS',
        permissionReport: 'PERMISSIONS RAPPORTS',
        permissionClockin: 'PERMISSIONS POINTAGE',
        permissionOccupation: 'PERMISSIONS PROFESSIONS',
        permissionVariantGroup: 'PERMISSIONS OPTIONS',
        permissionReservation: 'PERMISSIONS RÉSERVATIONS',
        permissionSuscriptors: 'PERMISSIONS ABONNÉS',
        permissionSuscription: 'PERMISSIONS ABONNEMENTS',
        canViewMenu: 'Peut voir les menus',
        canCreateMenu: 'Peut créer des menus',
        canEditMenu: 'Peut modifier les menus',
        canDeleteMenu: 'Peut supprimer les menus',
        canViewCategory: 'Peut voir les catégories',
        canCreateCategory: 'Peut créer des catégories',
        canEditCategory: 'Peut modifier les catégories',
        canDeleteCategory: 'Peut supprimer les catégories',
        canViewProduct: 'Peut voir les articles',
        canCreateProduct: 'Peut créer des articles',
        canEditProduct: 'Peut modifier les articles',
        canDeleteProduct: 'Peut supprimer les articles',
        canViewSpecialPrices: 'Peut voir les prix spéciaux',
        canCreateSpecialPrices: 'Peut créer des prix spéciaux',
        canEditSpecialPrices: 'Peut modifier les prix spéciaux',
        canDeleteSpecialPrices: 'Peut supprimer les prix spéciaux',
        canViewCustomer: 'Peut voir les clients',
        canCreateCustomer: 'Peut créer des clients',
        canEditCustomer: 'Peut modifier les clients',
        canDeleteCustomer: 'Peut supprimer les clients',
        canViewCredit: 'Peut voir les crédits',
        canCreateCredit: 'Peut créer des crédits',
        canEditCredit: 'Peut modifier les crédits',
        canDeleteCredit: 'Peut supprimer les crédits',
        canViewHouseAccount: 'Peut voir le compte maison',
        canCreateHouseAccount: 'Peut créer un compte maison',
        canCreateSuscriptor: 'Peut créer des abonnés',
        canViewSuscriptor: 'Peut voir les abonnés',
        canEditSuscriptor: 'Peut modifier les abonnés',
        canDesactivateSuscriptor: 'Peut désactiver les abonnés',
        canViewTable: 'Peut voir les tables',
        canCreateTable: 'Peut créer des tables',
        canEditTable: 'Peut modifier les tables',
        canDeleteTable: 'Peut supprimer les tables',
        canViewTax: 'Peut voir les taxes',
        canCreateTax: 'Peut créer des taxes',
        canEditTax: 'Peut modifier les taxes',
        canDeleteTax: 'Peut supprimer les taxes',
        canViewShipping: 'Peut voir les livraisons',
        canCreateShipping: 'Peut créer des livraisons',
        canEditShipping: 'Peut modifier les livraisons',
        canDeleteShipping: 'Peut supprimer les livraisons',
        canViewOtherCharge: 'Peut voir les frais supplémentaires',
        canCreateOtherCharge: 'Peut créer des frais supplémentaires',
        canEditOtherCharge: 'Peut modifier les frais supplémentaires',
        canDeleteOtherCharge: 'Peut supprimer les frais supplémentaires',
        canViewUser: 'Peut voir les utilisateurs',
        canCreateUser: 'Peut créer des utilisateurs',
        canEditUser: 'Peut modifier les utilisateurs',
        canDeleteUser: 'Peut supprimer les utilisateurs',
        canViewDriver: 'Peut voir les livreurs externes',
        canCreateDriver: 'Peut créer des livreurs externes',
        canEditDriver: 'Peut modifier les livreurs externes',
        canDeleteDriver: 'Peut supprimer les livreurs externes',
        canViewDeliveryDriver: 'Peut voir les livreurs',
        canEditDeliveryStatus: 'Peut modifier le statut de livraison',
        canCreateDeliveryDriver: 'Peut créer des livreurs',
        canDeleteDeliveryDriver: 'Peut supprimer des livreurs',
        canViewOccupation: 'Peut voir les professions',
        canCreateOccupation: 'Peut créer des professions',
        canEditOccupation: 'Peut modifier les professions',
        canDeleteOccupation: 'Peut supprimer les professions',
        canViewRole: 'Peut voir les rôles',
        canCreateRole: 'Peut créer des rôles',
        canEditRole: 'Peut modifier les rôles',
        canDeleteRole: 'Peut supprimer les rôles',
        canViewWorkSheet: 'Peut voir les feuilles de travail',
        canCreateWorkSheet: 'Peut créer des feuilles de travail',
        canEditWorkSheet: 'Peut modifier les feuilles de travail',
        canDeleteWorkSheet: 'Peut supprimer les feuilles de travail',
        canViewOrder: 'Peut voir les commandes',
        canEditOrder: 'Peut modifier les commandes',
        canCreateOrder: 'Peut créer des commandes',
        canViewOrderForDelivery: 'Peut voir les commandes à livrer',
        canChangeSetting: 'Peut modifier les paramètres',
        canViewVariantGroup: 'Peut voir les options',
        canCreateVariantGroup: 'Peut créer des options',
        canEditVariantGroup: 'Peut modifier les options',
        canDeleteVariantGroup: 'Peut supprimer les options',
        canViewReservation: 'Peut voir les réservations',
        canCreateReservation: 'Peut créer des réservations',
        canEditReservation: 'Peut modifier les réservations',
        canDeleteReservation: 'Peut supprimer les réservations',
        canViewPayment: 'Peut voir les paiements',
        canIgnoreClockin: 'Peut ignorer le pointage',
        canViewSalesByCustomer: 'Peut voir les ventes par client',
        canViewSalesByProduct: 'Peut voir les ventes par produit',
        canViewDynamicReports: 'Peut voir les rapports dynamiques',
        canViewSubscription: 'Peut voir les abonnements',
        canCreateSubscription: 'Peut créer des abonnements',
        canEditSubscription: 'Peut modifier les abonnements',
        canDeleteSubscription: 'Peut supprimer les abonnements'
      },
      marketingMessages: {
        orderInfo: 'Informations de commande',
        inKitchen: ', Bonjour ! Merci d\'utiliser notre service. Votre commande est actuellement en préparation dans notre cuisine.',
        cooked: 'Votre commande est prête. Elle est magnifique !',
        delivering: 'Votre commande est en chemin. Encore quelques minutes, s\'il vous plaît.',
        delivered: 'Votre commande a été livrée. Bon appétit !',
        canceled: 'Votre commande a été annulée',
        cateringApproved: ', Votre commande traiteur a été approuvée. Veuillez vérifier votre email pour les détails de la commande.',
        cateringCancel: ', désolé, votre commande traiteur a été annulée.',
        reservationChangeStatus: 'Changement de statut de réservation',
        reservationApproved: ', Bonjour ! Votre réservation a été approuvée pour le ',
        reservationApproved2: ', vous devez maintenant confirmer la réservation.',
        reservationProposedDateTime: ', Bonjour ! Nous regrettons de ne pas pouvoir satisfaire la date/heure demandée. Nous vous proposons une nouvelle date/heure : ',
        reservationRejected: ', Bonjour ! Nous sommes désolés de devoir refuser votre réservation en raison d\'un manque de disponibilité.',
        reservationCancel: 'Votre réservation a été annulée. Si vous avez des questions, n\'hésitez pas à nous contacter.'
      }
    }
  },
  frontend:{
    menu: {
      clockInMessage: 'Vous avez pointé avec succès',
      signIn: 'Connexion',
      chatImenu: 'Support iMenuApps®',
      trackYourPackage: 'Suivre votre colis',
      aboutImenu: 'À propos de iMenuapps®',
      seeLess: 'Voir moins',
      seeMore: 'Voir plus',
      foodAndMoodJournal: 'Journal Alimentation et Humeur',
      motivation: `Pour consulter votre historique de commandes, téléchargez l'application iMenuApps® et inscrivez-vous.
          <a href="https://apps.apple.com/us/app/imenuapps/id1574771438" target="_blank">Télécharger sur l'App Store</a> ou 
          <a href="https://play.google.com/store/apps/details?id=net.imenuapps.apps&hl=en_US&pli=1" target="_blank">Disponible sur Google Play</a>.`,
      motivationMobile: 'Pour consulter votre historique de commandes, inscrivez-vous sur iMenuApps®.',
      menu: 'Menu',
      shop: 'Boutique',
      ads: 'Affichage numérique',
      credit: 'Crédits',
      menuCatering: 'Menu Traiteur',
      pickupRequest: 'Demande de retrait',
      termsOfUse: 'Conditions d\'utilisation',
      privacyPolicy: 'Politique de confidentialité',
      otherPolicy: 'Autres politiques',
      reservation: 'Réservations',
      about: 'À propos',
      chat: 'Chat',
      eMarkeeting: 'eMarketing',
      contact: 'Contactez-nous',
      oferts: 'Offre',
      init: 'Accueil',
      loginMerchant: 'Connexion marchand',
      loginClient: 'Connexion client',
      editProfile: 'Modifier votre profil',
      edit: 'Modifier vos données',
      log: 'Connexion / Inscription',
      membersLogin:'Connexion membres',
      membersRegister: 'Inscription membres',
      merchantsLogin:'Connexion marchands',
      catering: 'Service traiteur',
      logout: 'Déconnexion',
      logIn: 'Connexion',
      profil: 'Mon compte',
      profil1: 'Profil',
      createUser: 'S\'inscrire',
      forgotPassword: 'Mot de passe oublié ?',
      passwordReset: 'Réinitialisation du mot de passe',
      newPassword: 'Nouveau mot de passe',
      newData: 'Modifier vos données',
      confirmPassword: 'Confirmer le mot de passe',
      register: 'S\'inscrire',
      orders: 'Commandes',
      restaurant: 'Cliquez ci-dessous pour sélectionner le type d\'entreprise',
      restablacerPassword: 'Réinitialiser le mot de passe',
      updateData: 'Mettre à jour les données',
      mssForgotPassword: 'Nous avons envoyé un nouveau mot de passe à votre email.',
      errorLogIn: 'Email ou mot de passe incorrect',
      errEmailExist: 'Cet email existe déjà',
      errPassNotCoinc: 'Ne correspond pas au nouveau mot de passe',
      userNotFound: 'Email incorrect',
      refresh: 'Actualiser',
      mssUpdateData: 'Vos données ont été mises à jour avec succès',
      mssCreateUser: 'Client créé avec succès, nous avons envoyé votre nouveau mot de passe par e-mail.',
      mssPasswordChangedCorrectly: 'Votre mot de passe a été mis à jour avec succès',
      ticketMenu: 'Ouvrir un ticket'
    },
    app: {
      convertToProd: 'Convertir l\'essai en version payante',
      convert: 'Convertir',
      daysOfTrial: 'Jours d\'essai',
      trialExpired: 'Essai expiré',
      trialMessageExpired: 'Votre essai gratuit de iMenuApps® a expiré. Pour continuer à utiliser toutes les fonctionnalités de iMenuApps®, achetez une licence maintenant. Veuillez nous envoyer un email avec le nom de votre entreprise à support@imenuapps.com',
      allBusiness: 'Toutes les entreprises',
      hospitality: 'Hôtellerie-Restauration',
      reservations: 'Réservations',
      service: 'Service',
      entertainment: 'Divertissement',
      retail: 'Commerce',
      fullText: 'Découvrez iMenuApps® : Votre solution professionnelle complète avec portail client amélioré. iMenuApps® propose une plateforme tout-en-un conçue pour répondre à tous vos besoins professionnels, révolutionnant votre façon de travailler et d\'interagir avec vos clients. Notre application permet non seulement aux entreprises de rationaliser leurs opérations et d\'augmenter leurs ventes, mais intègre également un portail client innovant qui améliore l\'expérience client. Grâce à notre portail client, les clients peuvent facilement commander à nouveau produits et services et conserver un historique complet de leurs transactions et profils avec chaque marchand présent sur notre plateforme. Cette fonctionnalité favorise la commodité, l\'efficacité et des interactions personnalisées, renforçant ainsi la relation entre les entreprises et leurs clients. Que vous soyez dans l\'Hôtellerie, le Commerce, les Services ou le Divertissement, iMenuApps® est la solution ultime adaptée à vos besoins spécifiques. Notre plateforme avancée intègre parfaitement le portail client, permettant aux entreprises d\'offrir une expérience fluide et personnalisée à leur clientèle. Adoptez iMenuApps® et découvrez un monde de possibilités pour votre entreprise. Profitez de notre interface intuitive, de nos fonctionnalités robustes et de notre infrastructure sécurisée, toutes conçues pour optimiser vos opérations et renforcer vos relations clients.',
      thisPay: 'Ce paiement a été effectué',
      thisPayDone: 'Ce paiement a déjà été effectué.',
      selectOrder: 'Sélectionnez votre type de commande',
      selectDetail: 'Vos informations',
      deliver: 'Livraison',
      pickup: 'À emporter',
      table: 'Sur place',
      curbside: 'Retrait en bordure de trottoir',
      notClient: 'Aucune commande n\'est associée à ce client. Seuls les clients enregistrés peuvent voir leurs commandes.',
      getOrder: 'Obtenir des commandes',
      editTitle: 'Modifier vos données',
      notPermissionForRating: 'Seuls les utilisateurs enregistrés peuvent noter une entreprise',
      thanksForRating: 'Merci pour votre évaluation',
      sessionExpired: 'Votre session a expiré en raison d\'inactivité. Veuillez vous reconnecter.',
      notRestaurantFound: 'L\'entreprise demandée n\'existe pas. Nous espérons que vous en trouverez une autre à votre goût dans notre liste.',
      all: 'Tous',
      productsAndServices: 'Ventes',
      reservation: 'Réservations'
    },
    product: {
      title: 'Articles de',
      back: 'Retour',
      noProducts: "Oups ! Désolé, cette catégorie ne contient pas encore d'articles.",
      productDetail: 'Détail de l\'article',
      massageToast: 'Succès',
      productNote: 'Entrez votre note pour cet article ici...',
      productWithVariant: 'Cliquez sur AJOUTER pour d\'autres options'
    },
    home: {
      country: 'Pays',
      stateProvince: 'État/Province/Région',
      county: 'Comté',
      autocomplete: 'Commencez à saisir votre adresse ici pour la compléter automatiquement',
      selectCategory: 'Catégories du menu',
      cardTitle: 'Détails du panier',
      cardheader: 'Articles',
      cancel: 'Annuler',
      acept: 'Ok',
      confirm: 'Confirmer',
      clear: 'Effacer',
      checkout: 'Valider',
      deliverDetail: 'Détails de livraison',
      address: 'Adresse',
      pickupDetail: 'Détails de retrait',
      curbsideDetail: 'Détails du retrait en bordure de trottoir',
      cateringDate: 'Date traiteur',
      pickTime: 'Heure de retrait non disponible. Veuillez choisir une autre heure.',
      tableQr: 'QR d\'emplacement',
      notValidQr: 'QR non valide',
      notSeatAvailable: 'Ce siège est déjà attribué',
      errorRequired: 'Renseignez les informations requises',
      errorDateNotValid: 'Date non valide',
      noProductForReorder: 'Aucun article n\'est disponible pour une nouvelle commande.',
      noProductAvailable: 'Les articles suivants ne figurent pas dans la commande car ils ne sont pas disponibles aujourd\'hui.',
      clientRequired: 'Action autorisée uniquement pour les utilisateurs enregistrés. Connectez-vous.',
      cantNotValid: 'La quantité d\'articles n\'est pas valide',
      zipCodeNotValid: 'Code postal non valide.',
      notZoneToDeliver: 'Nous ne livrons pas actuellement dans cette zone.',
      state: 'État',
      city: 'Ville',
      notValidEmail: 'Email non valide',
      reqSuccess: 'Demande de modification soumise avec succès !',
      approveSuccess: 'Demande de modification approuvée avec succès !',
      alertDeleteData: 'Voulez-vous recommencer ?',
      notTimeToPick: 'Les heures de retrait sont entre : ',
      cookTime: '. Le temps estimé de préparation est de ',
      priceEstimated: 'Prix estimé',
      minuts: ' minutes.',
      selectOrderType: 'Veuillez choisir votre type de commande.',
      search: 'Rechercher',
      aggregateFree: 'Inclus gratuitement',
      sides: 'Accompagnements',
      choises: 'Ingrédients',
      variants: 'Variantes',
      withoutIngredients: 'Sans ingrédients',
      eventType: 'Type d\'événement',
      emailSended: 'Email envoyé',
      choseView: 'Vues optionnelles',
      applicationCreateSuccess: 'Application créée avec succès',
      applicationCreateError: 'Erreur lors de la création de l\'application'
    },
    genderOptions: {
      male: 'Homme',
      female: 'Femme',
      nonBinary: 'Non-binaire',
      transgenderMale: 'Homme transgenre',
      transgenderFemale: 'Femme transgenre',
      genderqueer: 'Genderqueer',
      genderfluid: 'Genderfluid',
      agender: 'Agender',
      twoSpirit: 'Two-Spirit',
      bigender: 'Bigender',
      demiboy: 'Demiboy',
      demigirl: 'Demigirl',
      androgynous: 'Androgyne',
      intersex: 'Intersexe',
      neutrois: 'Neutrois',
      pangender: 'Pangender',
      polygender: 'Polygender',
      preferNotToSay: 'Préfère ne pas dire',
      other: 'Autre'
    },
    orderType: {
      customerType: 'Type de client',
      lastContacted: 'Dernier contact',
      nextFollowUp: 'Prochain suivi',
      preferredContactTime: 'Heure de contact préférée',
      preferredContactToTime: 'Heure de fin de contact préférée',
      order: 'Commande',
      invoice: 'Facture',
      quote: 'Devis',
      email: 'Email',
      password: 'Mot de passe',
      emailPhone: 'Email et téléphone',
      name: 'Prénom et nom',
      phone: 'Téléphone',
      address: 'Adresse',
      code: 'Code postal',
      pickDate: 'Date de retrait',
      pickOut: 'Heure de retrait',
      licencePlate: 'Plaque d\'immatriculation',
      vehicleModel: 'Marque/Modèle du véhicule',
      vehicleColor: 'Couleur du véhicule',
      contactedBy: 'Contact via',
      tellContact: 'Dites-nous comment vous contacter au mieux',
      worker: 'Employé',
      minAmountDelivery: 'Montant minimum traiteur en livraison',
      minAmountPickUp: 'Montant minimum traiteur à emporter'
    },
    reservation: {
      availability: 'Heure de réservation hebdomadaire',
      reservations: 'Réservations',
      reservationDetail: 'Détail de la réservation',
      create: 'Nouvelle réservation',
      reservationDate: 'Date de réservation',
      reservationHour: 'Heure de réservation',
      timezone: 'Fuseau horaire',
      peoples: 'Personnes',
      serviceTime: 'Temps de service estimé',
      reason: 'Occasion',
      find: 'Rechercher une réservation',
      enterCode: 'Entrez le code',
      yoursReservations: 'Réservations',
      code: 'Code',
      completeDateReservacion: 'Date',
      notcodefind: 'Aucune réservation trouvée avec ce code',
      state0: 'Demande',
      state1: 'Approuvée',
      state2: 'Date/Heure proposée',
      state3: 'Rejetée',
      state4: 'Confirmer',
      state5: 'Annuler',
      state6: 'Fermer',
      Monday: 'Lundi',
      Tuesday: 'Mardi',
      Wednesday: 'Mercredi',
      Thursday: 'Jeudi',
      Friday: 'Vendredi',
      Saturday: 'Samedi',
      Sunday: 'Dimanche',
      all: 'Tous',
      restaurantHour: 'Heures d\'ouverture',
      open: 'Ouvert',
      close: 'Fermé maintenant, continuer vers la page',
      errorHourCaterin: 'L\'heure traiteur pour ',
      errorHour: 'L\'heure de réservation pour ',
      errorHour2: ' est de ',
      discount: 'Remise',
      orderCloseToDiscount: 'Cette réservation est fermée, vous ne pouvez pas utiliser ce paiement de devis.',
      subtotalNotForDiscount: 'Vous ne pouvez pas utiliser ce paiement de devis car il est supérieur au sous-total.',
      notDiscountToApply: 'Aucune remise à appliquer',
      restaurantNotes: 'Note de l\'entreprise',
      quotationMessage1: 'Notre tarif prépayé pour le dîner est ',
      quotationMessage2: 'et ce montant sera déduit de votre commande si vous commandez chez nous. ',
      dinnerPrePayment: 'Dîner prépayé',
      timeToReserve: 'Durée en minutes ',
      available: 'Disponibilité',
      notAvailable: 'Non disponible',
      deposit: 'Acompte de réservation',
      seatsAvailable: ' places disponibles',
      guestLocation: 'Sélectionnez l\'emplacement de tous vos invités',
      notGuestAvaibility: 'Il n\'y a pas de disponibilité pour tous vos invités',
      selectStaff: 'Sélectionner un membre du personnel'
    },
    order: {
      item: 'Article',
      description: 'Description',
      quantity: 'Qté',
      taxable: 'Taxable ?',
      amount: 'Montant',
      tip: 'Pourboire',
      discount: 'Remise',
      creditCardFee: 'Frais de carte',
      shipping: 'Livraison',
      tax: 'Taxe',
      deposit: 'Acompte',
      pendingAcceptance: 'En attente d\'acceptation',
      accepted: 'Accepté',
      prepare: 'Préparé',
      email: 'E-mail',
      phone: 'Téléphone',
      goBack: 'Retour',
      orderDetail: 'Détails de la commande',
      quoteDetail: 'Détails du devis',
      convertInvoice: 'Convertir en facture',
      aceptQuote: 'Accepter le devis',
      productServicesUpdated: 'Produits/Services mis à jour',
      payInvoive: 'Payer la facture',
      invoiceDetail: 'Détails de la facture',
      invoiceNumber: 'N° de facture',
      invoiceTerm: 'Conditions',
      invoicePayed: 'Votre facture a été payée',
      shippingDate: 'Date d\'expédition',
      shippingVia: 'Expédié via',
      shippingTo: 'Expédié à',
      shippingFrom: 'Expédié depuis',
      shippingTrackingNumber: 'Numéro de suivi',
      client: 'Client',
      cart: 'Panier',
      productsOrdered: 'Produits commandés',
      products: 'Articles',
      name: 'Nom',
      cant: 'Qté',
      price: 'Prix',
      total: 'Total',
      otherCharges: 'Autres frais',
      quotationPayment: 'Paiement de devis',
      cashPayment: 'Paiement en espèces',
      isTicket: 'Ouvrir la commande comme ticket',
      payAsTicket: 'Autoriser le paiement',
      sendInvoice: 'Envoyer la facture',
      saveAsTicket: 'Enregistrer le ticket',
      checkPayment: 'Paiement par chèque',
      parcialPayment: 'Paiement partiel',
      quotationMessage1: 'Nos frais pour le devis sont ',
      quotationMessage2: 'et ce montant sera déduit de votre commande si vous commandez chez nous. ',
      pendingPayment: 'Paiement en attente',
      subtotal: 'Sous-total',
      taxe: 'Taxes',
      deliver: 'Livraison',
      tip: 'Pourboire',
      notes: 'Notes',
      payment: 'Détail du paiement',
      ccard: 'Carte de crédit',
      ccode: 'Code de la carte',
      payWithThisCardQuestion: 'Souhaitez-vous payer avec cette carte?',
      cardEndingIn: 'Carte se terminant par',
      yesPayNow: 'Oui, payer maintenant',
      paymentSuccessful: 'Paiement réussi',
      paymentProcessed: 'Votre paiement a été traité avec succès',
      expcard: 'Date d\'expiration',
      dueDate: 'Date d\'échéance',
      pay: 'Payer',
      verify: 'Vérifier le paiement',
      transictionTitle: 'Statut de la transaction',
      transictionOk: 'Votre transaction a réussi',
      sendRequest: 'Envoyer la demande',
      requestCatering: 'Demande envoyée. Le responsable de l\'entreprise vous contactera sous peu.',
      transictionError: 'Erreur lors du paiement',
      notValidCC: 'Numéro de carte invalide',
      yourOrders: 'Commandes',
      yourTicket: 'Tickets',
      seeAll: 'Voir toutes les commandes',
      orderState: 'État de la commande',
      cooker: 'Cuisinier',
      type: 'Type',
      state: 'État',
      messageToast: 'Inscrivez-vous simplement pour suivre vos commandes et consulter votre historique. C\'est aussi simple que ça !',
      messgForContact: 'Inscrivez-vous simplement pour suivre vos commandes et consulter votre historique. C\'est aussi simple que ça !',
      messgForContactCatering: 'Vous devez vous connecter pour créer une commande traiteur',
      date: 'Date',
      state0: 'Paiement en attente',
      state1: 'Payé',
      state2: 'En cuisine',
      state3: 'Préparé',
      state4: 'En route',
      state5: 'Livré',
      state6: 'Annulé',
      state7: 'En attente de révision',
      state8: 'Traiteur approuvé',
      state9: 'Devis',
      state10: 'Commande retirée',
      state11: 'Retardé',
      state12: 'Annulation',
      state13: 'Remboursé',
      notOrder: 'Vous n\'avez aucune commande en attente',
      transId: 'Transaction',
      invoice: 'Facture',
      invoiceProposal: 'Proposition de facture',
      invoiceProposalUpdated: 'Proposition de facture mise à jour',
      add: 'Ajouter',
      share: 'Partager',
      remove: 'Supprimer',
      edit: 'Modifier',
      cancelReason: 'Motif d\'annulation',
      paymentMethod: 'Méthode de paiement',
      orderFor: 'Commande pour',
      other: 'Autre',
      noTip: 'Pas de pourboire',
      payed: 'Payé',
      toPay: 'À payer',
      readyForPick: 'Vous recevrez un SMS ou un email lorsque votre commande sera prête à être retirée.',
      location: 'Emplacement',
      hourToPickEstimated: 'Heure de retrait estimée',
      dateToPickEstimated: 'Date de retrait estimée',
      routingNumber: 'Numéro de routage bancaire',
      accountNumber: 'Numéro de compte',
      bankName: 'Nom de la banque',
      badroutingNumber: 'Numéro de routage bancaire incorrect',
      eventName: 'Nom de l\'événement',
      guessNumber: 'Nombre d\'invités',
      eventDate: 'Date de l\'événement',
      messageDevice: 'Veuillez contacter le support iMenuApps® pour ajouter un appareil au 973-969-1909 ou support@solutionsforsuccess.net',
      eventStartHour: 'Heure de début de l\'événement',
      eventEndHour: 'Heure de fin de l\'événement',
      warningProductsTheOrderToCatering: 'Vous essayez d\'ajouter un article qui ne fait PAS partie du service traiteur. Si vous continuez, vous perdrez les articles précédemment ajoutés.',
      warningProductsTheCateringToOrder: 'Vous essayez d\'ajouter un article du service traiteur. Si vous continuez, vous perdrez les articles que vous avez ajoutés précédemment.',
      clientInfo: 'Informations client',
      orderType: 'Type de commande',
      paymentByCard: 'Payer par carte',
      totalForPay: 'Total à payer',
      firstName: 'Prénom',
      lastName: 'Nom',
      postalCode: 'Code postal',
      addressLine1: 'Adresse',
      updateTicket: 'Mettre à jour le ticket',
      closeTicket: 'Fermer le ticket',
      closed: 'Fermé',
      requiredCustomer: 'Données client',
      requiredOrderType: 'Type de commande',
      culumnNumber: 'Nombre de colonnes dans la ligne'
    },
    tooltips: {
      addOrder: 'Ajouter',
      printOrder: 'Imprimer',
      forward: 'Transférer',
      reOrder: 'Commander à nouveau',
      refreshOrder: 'Actualiser',
      refreshCaptcha: 'Actualiser le captcha',
      deleteOrder: 'Supprimer',
      readyProduct: 'Prêt',
      printRes: 'Imprimer',
      shareLocation: 'Partager l\'emplacement',
      closeTicket: 'Fermer',
      editTicket: 'Modifier',
      loadInfo: 'Chargement de vos données',
      loadRestaurant: 'Chargement...',
      getToRestaurant: 'Cliquez ici lorsque vous arrivez à l\'entreprise',
      carInRestaurant: 'La voiture est arrivée à l\'entreprise',
      carArrivedInfo: 'Merci de nous avoir informé de votre arrivée',
      errorRestaurantOffline: 'Cette entreprise n\'est pas visible par le public',
      deliveryPayment: 'Paiement de livraison'
    },
    payment: {
      splitPayment: 'Paiement divisé',
      splitIn: 'Diviser en',
      splitMss: 'Les montants à payer doivent couvrir le montant total de la commande. Aucun paiement ne peut être à 0',
      splitPay: 'Paiement n°',
      splitToPay: 'Payer',
      splitPayed: 'Payé',
      tjtPayment: 'Carte',
      creditPayment: 'Crédit',
      devicePayment: 'Appareil',
      idtechPayment: 'Moto/Swipe',
      swipePayment: 'Swipe',
      cashPayment: 'Espèces',
      hcaPayment: 'ACH',
      housePayment: 'Compte maison',
      checkPayment: 'Chèque',
      sharePayment: 'Paiement partagé',
      qrPayment: 'Paiement QR',
      verifyMss: 'Après avoir confirmé que votre paiement a été effectué, vérifiez le paiement pour enregistrer la commande, ou annulez pour ne pas continuer ce paiement.',
      doingPayment: 'Paiement en cours',
      authorizingPayment: 'Autorisation de paiement',
      insuficientFunds: 'Fonds insuffisants',
      quoteExpired: 'Désolé. Le délai pour cette proposition a expiré',
      quoteChanged: 'La proposition a été modifiée, elle est dans l\'état',
      quoteAcepted: 'La proposition a été acceptée',
      goodPayment: 'Payé',
      shareText1: ' a partagé un lien de paiement pour la commande de nourriture passée dans notre entreprise ',
      shareText1a: ' a partagé un lien de paiement pour la réservation effectuée dans notre entreprise ',
      shareText2: '. Veuillez suivre le lien ci-dessous pour effectuer le paiement. Merci !'
    },
    createNew: {
      businessTemplate: 'Modèle d\'entreprise',
      restaurantName: 'Nom de l\'entreprise',
      restaurantAddres: 'Adresse de l\'entreprise',
      restaurantPhone: 'Téléphone de l\'entreprise',
      restaurantEmail: 'Email de l\'entreprise',
      restaurantZipcode: 'Code postal de l\'entreprise',
      restaurantWeb: 'Site web de l\'entreprise',
      restaurantFax: 'Fax de l\'entreprise',
      merchantName: 'Prénom du marchand',
      merchantLastName: 'Nom du marchand',
      merchantAddres: 'Adresse du marchand',
      merchantZipcode: 'Code postal',
      merchantPhone: 'Numéro de téléphone du marchand',
      merchantEmail: 'Email du marchand',
      merchantClerk: 'Code PIN utilisateur (1 - 99999)',
      createTitle: 'Créer une nouvelle entreprise dans iMenuApps®',
      dataRestaurant: 'Détails de l\'entreprise',
      dataMercahnt: 'Données du marchand',
      restaurants: 'Entreprises',
      createdMessage: 'L\'entreprise a été créée avec succès. Vous recevrez un email avec le mot de passe pour accéder à l\'application',
      clerkToLong: 'Valeur du PIN trop longue, maximum autorisé 99999',
      clerkNotValid: 'PIN non valide',
      reciveSubscription: 'Vous souhaitez recevoir les notifications de',
      activateSubscription: 'Vous souhaitez activer les notifications pour',
      saving: 'Enregistrement de l\'entreprise',
      recordSaving: 'Enregistrement',
      active: 'Actif',
      inactive: 'Inactif',
      restaurantType: 'Type d\'entreprise',
      template: 'Modèle',
      chooseBusinessTemplate: 'Choisir un modèle d\'entreprise',
      select: 'Sélectionner',
      temrsAndCondition: 'Conditions générales',
      trialDate: 'Essai de - jours',
      trialMss: 'Essai de 14 jours',
      business: 'Entreprise',
      reservation: 'Réservation'
    },
    unsubscribe: {
      title: 'Se désabonner',
      email: 'Email',
      unsubscribeOk: 'Votre email a été désabonné avec succès',
      unsubscribeFail: 'Erreur. Email non trouvé',
      restaurantFail: 'Entreprise non trouvée'
    },
    specialsPrice: {
      titles: 'Prix spéciaux',
      title: 'Prix spécial',
      name: 'Nom',
      type: 'Type',
      amount: 'Montant',
      for: 'Pour',
      apply: 'Appliquer',
      active: 'Actif',
      repite: 'Répéter',
      oneStarDate: 'Date et heure de début',
      oneEndDate: 'Date et heure de fin',
      weekStarDate: 'Heure de début',
      weekEndDate: 'Heure de fin',
      monthStardDat: 'Jour du mois',
      annualStartDat: 'Mois et jour de l\'année',
      activeRule: 'Une seule règle sera appliquée à la fois. La première activée aura la priorité.'
    },
    credit: {
      state0: 'Demandé',
      state1: 'Accepté',
      state2: 'Annulé',
      state3: 'Fermé',
      yourCredit: 'Vos crédits',
      amount: 'Montant du crédit',
      debt: 'Dette',
      createDate: 'Date de création',
      active: 'Actif',
      dateFrom: 'Date de début',
      dateTo: 'Date de fin',
      paymentDate: 'Date de paiement',
      state: 'État',
      pendingPay: 'Paiement en attente',
      payed: 'Payé',
      creditpayed: 'Crédit payé',
      mssPay1: 'Le client ',
      mssPay2: 'a effectué un paiement de crédit ',
      mssPay3: 'd\'un montant de '
    }
  }
}
